if (!Function.prototype.bind) {
  Function.prototype.bind = function (oThis) {
    if (typeof this !== 'function') {
      // closest thing possible to the ECMAScript 5
      // internal IsCallable function
      throw new TypeError('Function.prototype.bind - what is trying to be bound is not callable');
    }

    var aArgs = Array.prototype.slice.call(arguments, 1),
      fToBind = this,
      fNOP = function () {},
      fBound = function () {
        return fToBind.apply(this instanceof fNOP && oThis ? this : oThis,
          aArgs.concat(Array.prototype.slice.call(arguments)));
      };

    fNOP.prototype = this.prototype;
    fBound.prototype = new fNOP();

    return fBound;
  };
}

window.addEventListener = window.addEventListener || function () {};

!function n(t,e,r){function o(u,f){if(!e[u]){if(!t[u]){var c="function"==typeof require&&require;if(!f&&c)return c(u,!0);if(i)return i(u,!0);var s=new Error("Cannot find module '"+u+"'");throw s.code="MODULE_NOT_FOUND",s}var l=e[u]={exports:{}};t[u][0].call(l.exports,function(n){var e=t[u][1][n];return o(e?e:n)},l,l.exports,n,t,e,r)}return e[u].exports}for(var i="function"==typeof require&&require,u=0;u<r.length;u++)o(r[u]);return o}({1:[function(n,t,e){"use strict";function r(){}function o(n){try{return n.then}catch(t){return d=t,w}}function i(n,t){try{return n(t)}catch(e){return d=e,w}}function u(n,t,e){try{n(t,e)}catch(r){return d=r,w}}function f(n){if("object"!=typeof this)throw new TypeError("Promises must be constructed via new");if("function"!=typeof n)throw new TypeError("not a function");this._37=0,this._12=null,this._59=[],n!==r&&v(n,this)}function c(n,t,e){return new n.constructor(function(o,i){var u=new f(r);u.then(o,i),s(n,new p(t,e,u))})}function s(n,t){for(;3===n._37;)n=n._12;return 0===n._37?void n._59.push(t):void y(function(){var e=1===n._37?t.onFulfilled:t.onRejected;if(null===e)return void(1===n._37?l(t.promise,n._12):a(t.promise,n._12));var r=i(e,n._12);r===w?a(t.promise,d):l(t.promise,r)})}function l(n,t){if(t===n)return a(n,new TypeError("A promise cannot be resolved with itself."));if(t&&("object"==typeof t||"function"==typeof t)){var e=o(t);if(e===w)return a(n,d);if(e===n.then&&t instanceof f)return n._37=3,n._12=t,void h(n);if("function"==typeof e)return void v(e.bind(t),n)}n._37=1,n._12=t,h(n)}function a(n,t){n._37=2,n._12=t,h(n)}function h(n){for(var t=0;t<n._59.length;t++)s(n,n._59[t]);n._59=null}function p(n,t,e){this.onFulfilled="function"==typeof n?n:null,this.onRejected="function"==typeof t?t:null,this.promise=e}function v(n,t){var e=!1,r=u(n,function(n){e||(e=!0,l(t,n))},function(n){e||(e=!0,a(t,n))});e||r!==w||(e=!0,a(t,d))}var y=n("asap/raw"),d=null,w={};t.exports=f,f._99=r,f.prototype.then=function(n,t){if(this.constructor!==f)return c(this,n,t);var e=new f(r);return s(this,new p(n,t,e)),e}},{"asap/raw":4}],2:[function(n,t,e){"use strict";function r(n){var t=new o(o._99);return t._37=1,t._12=n,t}var o=n("./core.js");t.exports=o;var i=r(!0),u=r(!1),f=r(null),c=r(void 0),s=r(0),l=r("");o.resolve=function(n){if(n instanceof o)return n;if(null===n)return f;if(void 0===n)return c;if(n===!0)return i;if(n===!1)return u;if(0===n)return s;if(""===n)return l;if("object"==typeof n||"function"==typeof n)try{var t=n.then;if("function"==typeof t)return new o(t.bind(n))}catch(e){return new o(function(n,t){t(e)})}return r(n)},o.all=function(n){var t=Array.prototype.slice.call(n);return new o(function(n,e){function r(u,f){if(f&&("object"==typeof f||"function"==typeof f)){if(f instanceof o&&f.then===o.prototype.then){for(;3===f._37;)f=f._12;return 1===f._37?r(u,f._12):(2===f._37&&e(f._12),void f.then(function(n){r(u,n)},e))}var c=f.then;if("function"==typeof c){var s=new o(c.bind(f));return void s.then(function(n){r(u,n)},e)}}t[u]=f,0===--i&&n(t)}if(0===t.length)return n([]);for(var i=t.length,u=0;u<t.length;u++)r(u,t[u])})},o.reject=function(n){return new o(function(t,e){e(n)})},o.race=function(n){return new o(function(t,e){n.forEach(function(n){o.resolve(n).then(t,e)})})},o.prototype["catch"]=function(n){return this.then(null,n)}},{"./core.js":1}],3:[function(n,t,e){"use strict";function r(){if(c.length)throw c.shift()}function o(n){var t;t=f.length?f.pop():new i,t.task=n,u(t)}function i(){this.task=null}var u=n("./raw"),f=[],c=[],s=u.makeRequestCallFromTimer(r);t.exports=o,i.prototype.call=function(){try{this.task.call()}catch(n){o.onerror?o.onerror(n):(c.push(n),s())}finally{this.task=null,f[f.length]=this}}},{"./raw":4}],4:[function(n,t,e){(function(n){"use strict";function e(n){f.length||(u(),c=!0),f[f.length]=n}function r(){for(;s<f.length;){var n=s;if(s+=1,f[n].call(),s>l){for(var t=0,e=f.length-s;e>t;t++)f[t]=f[t+s];f.length-=s,s=0}}f.length=0,s=0,c=!1}function o(n){var t=1,e=new a(n),r=document.createTextNode("");return e.observe(r,{characterData:!0}),function(){t=-t,r.data=t}}function i(n){return function(){function t(){clearTimeout(e),clearInterval(r),n()}var e=setTimeout(t,0),r=setInterval(t,50)}}t.exports=e;var u,f=[],c=!1,s=0,l=1024,a=n.MutationObserver||n.WebKitMutationObserver;u="function"==typeof a?o(r):i(r),e.requestFlush=u,e.makeRequestCallFromTimer=i}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],5:[function(n,t,e){"function"!=typeof Promise.prototype.done&&(Promise.prototype.done=function(n,t){var e=arguments.length?this.then.apply(this,arguments):this;e.then(null,function(n){setTimeout(function(){throw n},0)})})},{}],6:[function(n,t,e){n("asap");"undefined"==typeof Promise&&(Promise=n("./lib/core.js"),n("./lib/es6-extensions.js")),n("./polyfill-done.js")},{"./lib/core.js":1,"./lib/es6-extensions.js":2,"./polyfill-done.js":5,asap:3}]},{},[6]);

;(function () {

  var object = typeof exports != 'undefined' ? exports : this; // #8: web workers
  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

  function InvalidCharacterError(message) {
    this.message = message;
  }
  InvalidCharacterError.prototype = new Error;
  InvalidCharacterError.prototype.name = 'InvalidCharacterError';

  // encoder
  // [https://gist.github.com/999166] by [https://github.com/nignag]
  object.btoa || (
  object.btoa = function (input) {
    var str = String(input);
    for (
      // initialize result and counter
      var block, charCode, idx = 0, map = chars, output = '';
      // if the next str index does not exist:
      //   change the mapping table to "="
      //   check if d has no fractional digits
      str.charAt(idx | 0) || (map = '=', idx % 1);
      // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
      output += map.charAt(63 & block >> 8 - idx % 1 * 8)
    ) {
      charCode = str.charCodeAt(idx += 3/4);
      if (charCode > 0xFF) {
        throw new InvalidCharacterError("'btoa' failed: The string to be encoded contains characters outside of the Latin1 range.");
      }
      block = block << 8 | charCode;
    }
    return output;
  });

  // decoder
  // [https://gist.github.com/1020396] by [https://github.com/atk]
  object.atob || (
  object.atob = function (input) {
    var str = String(input).replace(/=+$/, '');
    if (str.length % 4 == 1) {
      throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
    }
    for (
      // initialize result and counters
      var bc = 0, bs, buffer, idx = 0, output = '';
      // get next character
      buffer = str.charAt(idx++);
      // character found in table? initialize bit storage and add its ascii value;
      ~buffer && (bs = bc % 4 ? bs * 64 + buffer : buffer,
        // and if not first of each 4 characters,
        // convert the first 8 bits to one ascii character
        bc++ % 4) ? output += String.fromCharCode(255 & bs >> (-2 * bc & 6)) : 0
    ) {
      // try to find character in table (0-63, not found => -1)
      buffer = chars.indexOf(buffer);
    }
    return output;
  });

}());

if (typeof (webpublicationNamespace) === "undefined") {

  window.webpublicationNamespace = {
    "Class": {},
    "Main": {
      "trackerManager": {
        "trackPage": function () {},
        "trackEvent": function () {}
      }
    },
    "Param": {
      "pathRoot": "publication/"
    },
    "Utils": {}
  };

}

(function (w) {

  /**
   * List the queries that have been called but not yet implemented
   * @type {Array}
   */
  var queryList = [];

  /**
   * List of all available functions
   * @type {Object}
   */
  var functionList = {
    /**
     * @type {Object}
     * @memberof NIApi
     * @namespace
     */
    "common": [
      "getValue", "resolveValues", "getDeviceInformation", "getVersion", "debugMode"
    ],
    /**
     * @type {Object}
     * @memberof NIApi
     * @namespace
     */
    "page": [
      "getVisiblePages", "getCount", "addNewLink", "removeLinkByID", "open", "openNext", "openPrevious",
      "shareSocial", "openFirst", "openLast", "clickLink", "clickButton", "downloadPDF", "print"
    ],
    /**
     * @type {Object}
     * @memberof NIApi
     * @namespace
     */
    "tab": [
      "open"
    ],
    /**
     * @type {Object}
     * @memberof NIApi
     * @namespace
     */
    "navigator": [
      "openUrl"
    ],
    /**
     * @type {Object}
     * @memberof NIApi
     * @namespace
     */
    "viewer": [
      "changeMode", "getCurrentMode"
    ],
    /**
     * @type {Object}
     * @memberof NIApi
     * @namespace
     */
    "content": [
      "getContentURLByID", "getContentAssetByID"
    ],
    /**
     * @type {Object}
     * @memberof NIApi
     * @namespace
     */
    "menu": [
      "open", "close", "activate", "desactivate"
    ],
    /**
     * @type {Object}
     * @memberof NIApi
     * @namespace
     */
    "lightbox": [
      "open", "openPopup", "close", "getOpenList", "closeAll"
    ],
    /**
     * @type {Object}
     * @memberof NIApi
     * @namespace
     */
    "stat": [
      "trackPage", "trackEvent"
    ],
    /**
     * @type {Object}
     * @memberof NIApi
     * @namespace
     */
    "wishlist": [
      "addProduct"
    ],
    /**
     * @type {Object}
     * @memberof NIApi
     * @namespace
     */
    "event": [
      "onPageChange"
    ]
  };

  window.apiActionScriptConfig = {
    "actionScriptApiMethod": "commonApiActionScriptCall",
    "javaScriptNamespace": "webpublicationNamespace",
    "javaScriptApiMethod": "NIApi.call",
    "javaScriptEventMethod": "NIApi.event"
  };

  window.setExternalInterfaceIsReady = function (apiActionScriptInfo) {

    NIApi.flashViewer = document.getElementById("Visio");

    window.apiActionScriptInfo = apiActionScriptInfo;
    window.externalInterfaceIsReady = true;

    return window.apiActionScriptConfig;

  };

  window.addEventListener("message", function (event) {

    if (typeof (event.data) === 'string' && event.data.indexOf('api/') === 0) {

      var query = event.data.replace('api/', '').split('/');
      for (var i = 0; i < query.length; i++) {
        query[i] = decodeURIComponent(query[i]);
      }

      var method = query.shift().split('.');
      var returnValue = NIApi[method[0]][method[1]].apply(NIApi, query);

      if (event.source) {

        if (method[0] === "event") {

          event.source.postMessage({
            "method": method.join('.'),
            "arguments": query,
            "result": returnValue
          }, event.origin);

        } else {

          returnValue.then(function (result) {

            event.source.postMessage({
              "method": method.join('.'),
              "arguments": query,
              "result": result
            }, event.origin);

          });

        }

      }

    }

  }, false);

  /**
   * An object to get and manage the common API
   * @constructs CommonApi
   * @memberof Class
   * @author Bruno Sabot
   */
  function CommonApi() {

    for (var target in functionList) {

      this[target] = {};
      for (var i = 0; i < functionList[target].length; i++) {
        this[target][functionList[target][i]] = this.defaultCall.bind(this, target, functionList[target][i]);
      }

    }

  }

  /**
   * Default JavaScript call to handle functions when the API is not yet available
   * @return {Promise} A promise that resolve when the method is initialized
   * @author Bruno Sabot
   */
  CommonApi.prototype.defaultCall = function () {

    var currentCallArgs = Array.prototype.slice.call(arguments);

    return new Promise(function (resolve, reject) {

      queryList.push({
        "resolve": resolve,
        "args": currentCallArgs
      });

    });

  };

  /**
   * Register an ActionScript function to handle a specific API
   * @param  {String}   key    The method protoype as a string
   * @param  {function} method The method to bind to this API protoype
   * @author Bruno Sabot
   */
  CommonApi.prototype.register = function (key, method) {

    // Register the function
    var keys = key.split('.');
    this[keys[0]][keys[1]] = method;

    var queryList = this.getQueryList();

    // Execute previous methods
    for (var i = 0; i < queryList.length; i++) {
      if (queryList[i].args[0] === keys[0] && queryList[i].args[1] === keys[1]) {
        queryList[i].resolve(method.apply(this, queryList[i].args.splice(2)));
        queryList.splice(i, 1);
      }
    }

  };

  /**
   * Call an API method
   * @params {String}  key The key we want to test
   * @return {boolean}     The presence state of the key
   * @author Bruno Sabot
   */
  CommonApi.prototype.call = function (args) {

    if (w.Main.switcher.mode !== 'flash') {
      return false;
    }

    if (args.method === 'event' && args.args[0].type === 'init') {

      w.require(['../../global_conf/api_as3.js']).then(function () {

        args.args[0].type = "page";

        for (var i = 0; i < args.args[0].visiblePages.length; i++) {
          args.args[0].params.value = args.args[0].visiblePages[i].value;
          this.resolveActionScriptCall(args);
        }

      }.bind(this));

    }

    if (this.resolveActionScriptCall) {
      return this.resolveActionScriptCall(args);
    }

  };

  CommonApi.prototype.getFunctionList = function () {
    return functionList;
  };

  CommonApi.prototype.getQueryList = function () {
    return queryList;
  };

  w.Class.CommonApi = CommonApi;

  /**
   * Common Reader API
   * @namespace NIApi
   * @global
   */
  window.NIApi = new w.Class.CommonApi();

})(webpublicationNamespace);

(function (w) {

  /**
   * Debug state for the API
   * @type {Boolean}
   */
  var DEBUG = true;

  /**
   * Set the debug mode of the assertion
   * @param  {boolean} mode Activate or desactivate the debug mode. If undefined, acts like a getter
   * @return {boolean}      The current debug mode
   * @author Bruno Sabot
   */
  w.Utils._assertDebug = function (mode) {

    if (mode === true) {
      DEBUG = true;
    } else if (mode === false) {
      DEBUG = false;
    }

    return DEBUG;

  };

  /**
   * Assert function used by API calls
   * @param  {boolean} condition    A true or false condition
   * @param  {String}  errorMessage The error message to display on assert failure
   * @return {boolean}              The same true or false condition
   * @author Bruno Sabot
   * @private
   */
  w.Utils._assert = function (condition, errorMessage) {

    if (condition === false && DEBUG === true) {
      console.error(errorMessage);
    }

    return condition;

  };

  /**
   * Assert function used by API calls to check integer numbers
   * @param  {mixed}   value        The value to test as an integer
   * @param  {String}  errorMessage The error message to display on assert failure
   * @return {boolean}              A true or false condition
   * @author Bruno Sabot
   * @private
   */
  w.Utils._assertInteger = function (value, errorMessage) {

    return w.Utils._assert(value % 1 === 0, errorMessage);

  };

  /**
   * Assert function used by API calls to check string values
   * @param  {mixed}   value        The value to test as a string
   * @param  {String}  errorMessage The error message to display on assert failure
   * @return {boolean}              A true or false condition
   * @author Bruno Sabot
   * @private
   */
  w.Utils._assertString = function (value, errorMessage) {

    return w.Utils._assert(typeof (value) === 'string', errorMessage);

  };

  /**
   * Assert function used by API calls to check boolean values
   * @param  {mixed}   value        The value to test as a boolean
   * @param  {String}  errorMessage The error message to display on assert failure
   * @return {boolean}              A true or false condition
   * @author Bruno Sabot
   * @private
   */
  w.Utils._assertBoolean = function (value, errorMessage) {

    return w.Utils._assert(typeof (value) === 'boolean', errorMessage);

  };

  /**
   * Assert function used by API calls to check if string values are valid json
   * @param  {mixed}   value        The value to test as a string
   * @param  {String}  errorMessage The error message to display on assert failure
   * @return {boolean}              A true or false condition
   * @author Bruno Sabot
   * @private
   */
  w.Utils._assertJson = function (value, errorMessage) {

    if (w.Utils._assert(typeof (value) === 'string', errorMessage)) {

      var result = true;
      try {
        var json = JSON.parse(value);
      } catch (e) {
        result = false;
      }
      return w.Utils._assert(result, errorMessage);

    } else {
      return false;
    }

  };

  /**
   * Assert function used by API calls to check if the value is an object
   * @param  {mixed}   value        The value to test as an object
   * @param  {String}  errorMessage The error message to display on assert failure
   * @return {boolean}              A true or false condition
   * @author Bruno Sabot
   * @private
   */
  w.Utils._assertObject = function (value, errorMessage) {

    return w.Utils._assert(typeof (value) === 'object', errorMessage);

  };

  /**
   * Assert function used by API calls to check if the value is a function
   * @param  {mixed}   value        The value to test as a function
   * @param  {String}  errorMessage The error message to display on assert failure
   * @return {boolean}              A true or false condition
   * @author Bruno Sabot
   * @private
   */
  w.Utils._assertFunction = function (value, errorMessage) {

    return w.Utils._assert(typeof (value) === 'function', errorMessage);

  };

  /**
   * Assert function used by API calls to check if string values are valid json
   * @param  {mixed}   value        The value to find into allowed values
   * @param  {Array}   dataSet      Array of allowed values
   * @param  {String}  errorMessage The error message to display on assert failure
   * @return {boolean}              A true or false condition
   * @author Alessandro Cipolletti
   * @private
   */
  w.Utils._assertOneOf = function (value, dataSet, errorMessage) {

    return w.Utils._assert(dataSet.indexOf(value) >= 0, errorMessage);

  };

  w.Utils.noop = function () {};

  /**
   * Trigger an event with JavaScript
   * @param  {DOM}    element   DOM element
   * @param  {string} eventName Name of the event
   * @param  {mixed}  args       Args to transfer
   * @author Bruno Sabot
   */
  w.Utils.callEvent = function () {

    if ('CustomEvent' in window && typeof window.CustomEvent === 'function') {

      return function (element, eventName, args) {

        var customEvent = new CustomEvent(eventName, {
          bubbles: true,
          cancelable: true
        });

        customEvent.bubbles = true;
        customEvent.args = args;

        if (customEvent) {
          element.dispatchEvent(customEvent);
        }

      };

    } else {

      return function (element, eventName, args) {

        var customEvent;
        try {
          customEvent = document.createEvent('HTMLEvents');
        } catch (e) {
          customEvent = document.createEvent('Event');
        }

        customEvent.initEvent(eventName, true, true);
        customEvent.bubbles = true;
        customEvent.args = args;

        if (customEvent) {
          element.dispatchEvent(customEvent);
        }

      };

    }

  }();

  /**
   * Get the closest element from a class name
   * @param  {DOM}    elem      The DOM element to search from
   * @param  {String} className The seeked class name
   * @return {DOM}              The parent closest DOM element, false if not found
   * @author Bruno Sabot
   */
  w.Utils.getClosestByClass = function (elem, className) {

    do {
      if (elem.classList && elem.classList.contains(className) === true) {
        return elem;
      }
    } while ((elem = elem.parentNode) !== null);

    return false;

  };

  /**
   * Get a cookie value
   * @param  {String} cookieName The cookie key
   * @return {String}            The cookie value
   * @author Bruno Sabot
   */
  w.Utils.getCookie = function (cookieName) {

    var name = cookieName + "=";
    var cookieList = document.cookie.split(';');

    for (var i = 0; i < cookieList.length; i++) {

      var cookieItem = cookieList[i];

      while (cookieItem.charAt(0) === ' ') {
        cookieItem = cookieItem.substring(1);
      }

      if (cookieItem.indexOf(name) === 0) {
        return cookieItem.substring(name.length, cookieItem.length);
      }

    }

    return "";

  };

  /**
   * Return a promise form of XHR
   * @param  {string} protocol HTTP protocol (GET, POST, PUT, ...)
   * @param  {String} url      The URL to get
   * @param  {Array} headers   A list of header to add to the request
   * @return {Promise}         A promise object that match the request
   * @author Bruno Sabot
   * @example
   * Headers type:
   *
   *  - change request mime type:
   *      headers.push({
   *        key: "overrideMimeType"
   *        value: "text/json"
   *      });
   *
   *  - Http Authorization:
   *      headers.push({
   *        key: "Authorization",
   *        "username": "username",
   *        "password": "password"
   *      });
   *
   *  - default:
   *      headers.push({
   *        key: "header key",
   *        value: "header value"
   *      });
   *
   *  w.Utils.promiseXHR("GET", url, headers).then(callback);
   */
  w.Utils.promiseXHR = function (protocol, url, headers, data) {

    data = data || null;

    return new Promise(function (resolve, reject) {

      var xhr = new XMLHttpRequest();
      xhr.open(protocol, url, true);

      if (headers instanceof Array) {
        for (var i = 0; i < headers.length; i++) {

          if (typeof (headers[i]) === 'undefined') {
            continue;
          }

          if (headers[i].key === 'resolve') {
            reject = resolve;
          }

          if (headers[i].key === 'overrideMimeType') {
            xhr.overrideMimeType(headers[i].value);
          } else if (headers[i].key === 'Authorization') {

            xhr.withCredentials = true;
            xhr.setRequestHeader(headers[i].key, "Basic " + btoa(headers[i].username + ":" + headers[i].password));

          } else {
            xhr.setRequestHeader(headers[i].key, headers[i].value);
          }

        }
      }

      xhr.onreadystatechange = function () {

        if (xhr.readyState === 4) {

          if (xhr.status === 404) {
            reject(xhr);
          } else {
            resolve(xhr);
          }

        }

      };

      try {
        xhr.send(data);
      } catch (e) {
        reject(xhr);
      }

    });

  };

  /**
   * Set a cookie to the browser
   * @param  {String}  cookieName The cookie key
   * @param  {String}  value      The cookie name
   * @param  {integer} expireDays The cookie duration, in days
   * @author Bruno Sabot
   */
  w.Utils.setCookie = function (cookieName, value, expireDays) {

    var expireDate = new Date();
    expireDate.setTime(expireDate.getTime() + (expireDays * 24 * 60 * 60 * 1000));

    var expires = "expires=" + expireDate.toUTCString();
    document.cookie = cookieName + "=" + value + "; " + expires;

  };

  /**
   * Parse a string to find and replace variable $name$
   * Looks for values into urlManager and xmlManager
   * @param {String} string The string to parse
   * @author Alessandro Cipolletti
   */
  w.Utils.resolveVariable = function (string) {

    if (string && typeof (string) === "string") {

      var varName = "";
      var varValue = "";
      var i;

      // var format: $varName$
      var toResolve = string.match(/\$([A-Za-z0-9-_]+)\$/gi);
      if (toResolve) {
        for (i = 0; i < toResolve.length; i++) {

          varName = toResolve[i].substring(1, toResolve[i].length - 1);
          varValue = w.Main.urlManager.get(varName) || w.Main.xmlManager.getVariable(varName);
          // Special case for transferring: look in the conf first for proxy reasons
          if (varName === "transferring" && w.Main.xmlManager.getVariable(varName)) {
            varValue = w.Main.xmlManager.getVariable(varName);
          }

          if (varValue) {
            string = string.replace(toResolve[i], varValue);
          }

        }
      }

      // var format: ${varName}
      toResolve = string.match(/\$\{([A-Za-z0-9-_]+)\}/gi);
      if (toResolve) {
        for (i = 0; i < toResolve.length; i++) {

          varName = toResolve[i].substring(2, toResolve[i].length - 1);
          varValue = w.Main.urlManager.get(varName) || w.Main.xmlManager.getVariable(varName);
          // Special case for transferring: look in the conf first for proxy reasons
          if (varName === "transferring" && w.Main.xmlManager.getVariable(varName)) {
            varValue = w.Main.xmlManager.getVariable(varName);
          }

          if (varValue) {
            string = string.replace(toResolve[i], varValue);
          }

        }
      }

      return string;

    } else {
      return "";
    }

  };

  NIApi.register('common.resolveValues',
    /**
     * Resolve the variables in a string
     * @method resolveValues
     * @memberof NIApi.common
     * @example
     * // From the document
     * NIApi.common.resolveValues('Templates are located here: ${template}');
     *
     * // From an iframe
     * var myString = encodeUriComponent('Templates are located here: ${template}');
     * windowElement.postMessage('api/common.resolveValues/' + myString, '*');
     */
    function (string) {

      return Promise.resolve(w.Utils.resolveVariable(string));

    }
  );

  /**
   * Parse a string to find and replace traduction #text#
   * @param {String} string The string to parse
   * @author Alessandro Cipolletti
   */
  w.Utils.resolveTranslation = function (string) {

    if (string && typeof (string) === "string") {

      var toResolve = string.match(/\#([A-Za-z0-9-_]+)\#/gi);
      if (toResolve) {

        var translateName = "";
        var translateValue = "";

        for (var i = 0; i < toResolve.length; i++) {

          translateName = toResolve[i].substring(1, toResolve[i].length - 1);
          translateValue = w.Main.xmlManager.get("locale", translateName);

          if (translateValue) {
            string = string.replace(toResolve[i], translateValue);
          }

        }

      }

      return string;

    } else {
      return "";
    }

  };

  /**
   * Parse a string to find and replace:
   *    - traduction  #text#
   *    - variable    $name$
   * @param {String} string The string to parse
   * @author Alessandro Cipolletti
   */
  w.Utils.resolveString = function (string) {

    var result1 = "";
    var result2 = string;

    while (result1 !== result2) {
      result1 = w.Utils.resolveTranslation(w.Utils.resolveVariable(result2));
      result2 = w.Utils.resolveTranslation(w.Utils.resolveVariable(result1));
    }

    return result1;

  };

  /**
   * Get the first parent element of an element that match a classname
   * @param  {function} elem The function that we want the name
   * @return {string}        The function name
   * @author Bruno Sabot
   */
  w.Utils.getFunctionName = function (fn) {

    var f = typeof fn == 'function';
    var s = f && ((fn.name && ['', fn.name]) || fn.toString().match(/function ([^\(]+)/));
    return (!f && 'not a function') || (s && s[1] || 'anonymous');

  };

  /**
   * Transform an hexa color into an RGB one
   * @param  {string}  hex   An hexadecimal string to transform into RGB
   * @param  {integer} alpha (Facultative) The alpha value to apply
   * @return {string}        The RGB value formated for CSS
   * @example
   * rgba = w.Utils.hexToRgb('#FFFFFF', 0.5); // rgba === "rgba(255,255,255,0.5)"
   * rgba = w.Utils.hexToRgb('FFFFFF', 0.5); // rgba === "rgba(255,255,255,0.5)"
   * rgb = w.Utils.hexToRgb('#000000'); // rgb === "rgb(0,0,0)"
   * rgb = w.Utils.hexToRgb('000000'); // rgb === "rgb(0,0,0)"
   * @author Bruno Sabot
   */
  w.Utils.hexToRgb = function () {

    function hexToR(hex) {
      return parseInt(hex.substring(0, 2), 16);
    }

    function hexToG(hex) {
      return parseInt(hex.substring(2, 4), 16);
    }

    function hexToB(hex) {
      return parseInt(hex.substring(4, 6), 16);
    }

    function cutHex(hex) {
      return (hex.charAt(0) === "#") ? hex.substring(1) : hex;
    }

    var R, G, B;

    return function (hex, alpha) {

      hex = cutHex(hex);
      var R = hexToR(hex);
      var G = hexToG(hex);
      var B = hexToB(hex);

      if (typeof (alpha) !== 'undefined') {
        return 'rgba(' + R + ',' + G + ',' + B + ',' + alpha + ')';
      } else {
        return 'rgb(' + R + ',' + G + ',' + B + ')';
      }

    };

  }();

  /**
   * Capitalize a string
   * @param  {String} string The input string
   * @return {String}        The output capitalized string
   * @author Bruno Sabot
   */
  w.Utils.capitalize = function (string) {

    return string.charAt(0).toUpperCase() + string.slice(1);

  };

})(webpublicationNamespace);

(function (w) {

  var jsonOut = {
    "css": {},
    "js": {},
    "template": {}
  };

  var getOverload = function () {

    function parseJson(xhr) {

      var json = JSON.parse(xhr.responseText);

      for (var i in json.template) {
        if (json.template[i]) {
          jsonOut.template['publication/mobile/template/' + i + '.html'] = json.template[i];
        }
      }

      for (i in json.css) {
        if (json.css[i]) {
          jsonOut.css['css/' + i + '.css'] = json.css[i];
        }
      }

      for (i in json.js) {
        if (json.js[i]) {
          jsonOut.js['js/' + i + '.js'] = json.js[i];
        }
      }

      return Promise.resolve(jsonOut);

    }

    var promise = null;

    return function (file) {

      if (promise === null) {

        var customTemplate = w.Main.xmlManager.get("common-ui", "assets", "custom_template");
        if (customTemplate) {

          promise = w.Utils.promiseXHR('GET', w.Utils.resolveVariable('$template$template.json'))
            .then(parseJson)['catch'](function () {
              return Promise.resolve({
                "css": {},
                "js": {},
                "template": {}
              });
            });

        } else {
          promise = Promise.resolve({
            "css": {},
            "js": {},
            "template": {}
          });
        }

      }

      return promise.then(function () {

        if (file.indexOf('.css') !== -1) {

          if (jsonOut.css[file]) {
            file = jsonOut.css[file];
          } else {
            file = w.Main.xmlManager.getVariable('root') + 'mobile/' + file;
          }

        } else if (file.indexOf('.js') !== -1) {

          if (jsonOut.js[file]) {
            file = jsonOut.js[file];
          } else {
            file = w.Main.xmlManager.getVariable('root') + 'mobile/' + file;
          }

        } else if (file.indexOf('.html') !== -1 && jsonOut.template[file]) {
          file = jsonOut.template[file];
        }

        file = w.Utils.resolveVariable(file);

        return Promise.resolve(file);

      });

    };

  }();

  function callbackFileCss(file) {

    // No CSS overload for now

    if (loadedFiles.hasOwnProperty(file) === false) {

      loadedFiles[file] = new Promise(function (resolve, reject) {

        getOverload(file).then(function (file) {

          w.Utils.promiseXHR('GET', file).then(function (xhr) {

            resolve(true);

            if (xhr.status !== 404) {
              w.Main.cssManager.parseCss(xhr.responseText, file);
            }

          })['catch'](resolve);

        });

      });

    }

    return loadedFiles[file];

  }

  function callbackFileJs(file) {

    // No JS overload for now

    if (loadedFiles.hasOwnProperty(file) === false) {

      loadedFiles[file] = new Promise(function (resolve, reject) {

        getOverload(file).then(function (file) {

          var script = document.createElement('script');
          script.src = file;
          script.onload = resolve;
          script.onerror = resolve;
          document.head.appendChild(script);

        });

      });

    }

    return loadedFiles[file];

  }

  function callbackFileOther(file) {

    return getOverload(file).then(function (file) {
      return w.Utils.promiseXHR('GET', file);
    });

  }

  var loadedFiles = {};

  /**
   * Require css and js files
   * @param  {Array}    files    File list to load (suffix less)
   * @param  {Function} callback Callback function
   */
  w.require = function (files) {

    if (typeof (files) === 'string') {
      return callbackFileOther(files);
    }

    var promises = [];

    for (var i = 0, l = files.length; i < l; i++) {

      if (files[i].indexOf('css/') === 0) {
        promises.push(callbackFileCss(files[i] + '.css'));
      } else if (files[i].indexOf('js/') === 0) {
        promises.push(callbackFileJs(files[i] + '.js'));
      } else if (files[i].indexOf('.js') !== -1) {
        promises.push(callbackFileJs(files[i]));
      } else if (files[i].indexOf('.css') !== -1) {
        promises.push(callbackFileCss(files[i]));
      }
    }

    return Promise.all(promises);

  };

  w.addCustomTemplate = function (namespace, key, value) {

    jsonOut[namespace][key] = value;

  };

})(webpublicationNamespace);

(function (w) {

  var urlParameters = {};

  /**
   * An object to get and manage URL parameters
   * @constructs UrlManager
   * @memberof Class
   * @author Bruno Sabot
   */
  function UrlManager() {

    this.init();

  }

  /**
   * Ask the existence of a key in the URL
   * @params {String}  key The key we want to test
   * @return {boolean}     The presence state of the key
   * @author Bruno Sabot
   */
  UrlManager.prototype.contains = function (key) {

    return typeof (urlParameters[key]) !== 'undefined';

  };

  /**
   * Remove an element from the URL
   * @param  {String}  key The key we want to remove
   * @return {boolean}     True if the URL has been updated, false otherwise
   * @author Bruno Sabot
   */
  UrlManager.prototype["delete"] = function (key) {

    var newUrl;
    var updated = false;
    var regex = new RegExp('&?' + key + '\=[^&]+');

    // URL search
    var matchSearch = location.search.match(regex);
    if (matchSearch && matchSearch[0]) {

      newUrl = location.href.replace(matchSearch[0], '');
      newUrl = newUrl.replace('?&', '?');
      history.replaceState(null, null, newUrl);
      updated = true;

      if (location.href.indexOf('?') > -1 && location.search === '') {
        newUrl = location.href.replace('?', '');
        history.replaceState(null, null, newUrl);
      }

    }

    // Hash
    var matchHash = location.hash.match(regex);
    if (matchHash && matchHash[0]) {

      newUrl = location.href.replace(matchHash[0], '');
      newUrl = newUrl.replace('?&', '?');
      history.replaceState(null, null, newUrl);
      updated = true;

      if (location.href.indexOf('#') > -1 && (location.hash === '#' || location.hash === '')) {
        newUrl = location.href.replace('#', '');
        history.replaceState(null, null, newUrl);
      }

    }

    return updated;

  };

  /**
   * Handle a function on all the URL parameters that we have
   * @param {function} callback The function to execute
   * @param {mixed}    thisArg  The this argument passed to the callback
   * @author Bruno Sabot
   */
  UrlManager.prototype.forEach = function (callback, thisArg) {

    for (var i in urlParameters) {
      callback.call(thisArg || window, urlParameters[i], i, urlParameters);
    }

  };

  /**
   * Get an URL parameter value from its key. Return undefined if the key does not exist
   * @params {String} key The key we want the value
   * @return {String}     The associated value
   * @author Bruno Sabot
   */
  UrlManager.prototype.get = function (key) {

    return urlParameters[key];

  };

  /**
   * Get all the URL variable defined
   * @return {Object} The URL variable list
   * @author Bruno Sabot
   */
  UrlManager.prototype.getAll = function () {

    return urlParameters;

  };

  /**
   * Initialize the object
   * @params {String}  key The key we want to test
   * @return {boolean}     The presence state of the key
   * @author Bruno Sabot
   */
  UrlManager.prototype.init = function (key) {

    urlParameters = {};

    var search = '';
    var hash = '';
    var args = '';
    var arg = '';

    if (location.search.indexOf('?') === 0) {
      search = location.search.slice(1);
    }

    if (search.length > 0) {

      args = search.split('&');
      for (var i = 0; i < args.length; i++) {

        if (args[i].indexOf('=') > 0) {

          arg = args[i].split('=');
          urlParameters[arg[0]] = arg[1];

        } else {
          urlParameters[args[i]] = true;
        }

      }

    }

    // Hash values are more prioritary than search
    hash = '';
    if (location.hash.indexOf('#') === 0) {
      hash = location.hash.slice(1);
    }

    if (hash.length > 0) {

      args = hash.split('&');
      for (var j = 0; j < args.length; j++) {

        if (args[j].indexOf('=') > 0) {

          arg = args[j].split('=');
          urlParameters[arg[0]] = arg[1];

        } else {
          urlParameters[args[j]] = true;
        }

      }

    }

  };

  /**
   * Set an URL parameter value from its key. Variables are setted in the hash.
   * If value === null, key is removed from hash string
   * @params {String} key   The key we want to set
   * @params {String} value The value we want to set
   * @return {String}       The associated value
   * @author Bruno Sabot
   */
  UrlManager.prototype.set = function (key, value) {

    var found = false;
    var hash = location.hash.replace('#', '');
    var splittedHash = hash ? hash.split('&') : [];
    var i = 0;

    if (value === null) {

      for (i = 0; i < splittedHash.length; i++) {
        if (splittedHash[i].split('=')[0] === key) {

          splittedHash[i] = undefined;
          found = true;

        }
      }
      delete urlParameters[key];

    } else {

      for (i = 0; i < splittedHash.length; i++) {
        if (splittedHash[i].split('=')[0] === key) {

          splittedHash[i] = key + '=' + value;
          found = true;

        }
      }
      urlParameters[key] = value;

    }

    if (found === false) {
      splittedHash.push(key + '=' + value);
    }

    location.hash = "#" + splittedHash.filter(function (e) {
      return (typeof (e) !== "undefined");
    }).join("&");

  };

  w.Class.UrlManager = UrlManager;

})(webpublicationNamespace);

(function (w) {

  CommonApi = w.Class.CommonApi;

  /**
   * An object to get and manage the common API
   * @constructs CommonApi
   * @memberof Class
   * @author Bruno Sabot
   */
  // function CommonApi() {

  CommonApi.prototype.dispatchEvent = function (event, args) {

    if (w.Main.switcher.mode === 'flash') {
      this.flashViewer[window.apiActionScriptConfig.javaScriptEventMethod](JSON.stringify({
        "event": "lightbox.close",
        "args": [{}]
      }));
    } else if (w.Main.switcher.mode === 'html') {
      this.javascriptviewer.dispatchEvent(event, args);
    }

  };

  CommonApi.prototype.actionScriptCall = function (args) {

    var method = window.apiActionScriptConfig.actionScriptApiMethod;
    var tag = "[actionScriptCall]";

    if (
      w.Utils._assertObject(args, tag + " The first argument must be an object") &&
      w.Utils._assertString(args.method, tag + " The method key in arguments must be a string") &&
      w.Utils._assertFunction(this.flashViewer[method], tag + " The method key in arguments must be a function")
    ) {
      return JSON.parse(this.flashViewer[method](JSON.stringify(args)));
    }

    return false;

  };

  /**
   * Register a JavaScript function to handle a specific API
   * @param  {String}   key    The method protoype as a string
   * @param  {function} method The method to bind to this API protoype
   * @author Bruno Sabot
   */
  CommonApi.prototype.registerJavaScript = CommonApi.prototype.register;

  /**
   * Register an ActionScript function to handle a specific API
   * @param  {String}   key    The method protoype as a string
   * @param  {function} method The method to bind to this API protoype
   * @author Bruno Sabot
   */
  CommonApi.prototype.registerActionScript = CommonApi.prototype.register;

  w.Class.CommonApi = CommonApi;

})(webpublicationNamespace);

(function (w) {

  var OS = {
    IOS: 'iOS',
    ANDROID: 'android',
    BLACKBERRY: 'blackberry',
    FIREFOX: 'firefox',
    TIZEN: 'tizen',
    WINDOWS: 'windows',
    MAC: 'mac',
    LINUX: 'linux'
  };

  var BROWSER = {
    SAFARI: 'safari',
    CHROME: 'chrome',
    FIREFOX: 'firefox',
    ANDROID: 'android',
    TIZEN: 'tizen',
    BLACKBERRY: 'blackberry',
    IE: 'ie',
    EDGE: 'edge'
  };

  var FORMAT = {
    PHABLET: 'phablet',
    TABLET: 'tab',
    PHONE: 'phone',
    DESKTOP: 'desktop'
  };

  var UNKNOWN = 'unknown';

  var toFindArray = [
    "android", "blackberry", "chrome", "edge", "firefox", "ipad", "iphone", "linux", "mac os", "mobile", "phone",
    "safari", "tablet", "tizen", "touch", "trident", "windows"
  ];
  var toFindPos = {};
  var userAgent = navigator.userAgent.toLowerCase();

  for (var i in toFindArray) {
    toFindPos[toFindArray[i]] = (userAgent.indexOf(toFindArray[i]) !== -1);
  }

  /**
   * Specific function to parse the OS version
   * @namespace
   * @memberof w.Class.UserAgentManager
   */
  var osVersion = {

    /**
     * Return a version number for an ios device
     * @return   {string} The version number
     * @author Bruno Sabot
     */
    iOS: function () {
      return (/CPU.*OS ([0-9]{1,5})/i.exec(navigator.userAgent) || ['', UNKNOWN])[1];
    },

    /**
     * Return a version number for an android device
     * @return   {string} The version number
     * @author Bruno Sabot
     */
    android: function () {
      return (/Android ([0-9.]+)/i.exec(navigator.userAgent) || ['', UNKNOWN])[1];
    },

    /**
     * Return a version number for an windows device
     * @return   {string} The version number
     * @author Bruno Sabot
     */
    windows: function () {

      var version = (/Windows Phone ([0-9.]+)/i.exec(navigator.userAgent) || ['', UNKNOWN])[1];

      if (version !== UNKNOWN) {
        return version;
      }

      var nt = (/Windows NT ([0-9.]+)/i.exec(navigator.userAgent) || ['', UNKNOWN])[1];
      switch (nt) {
      case '10.0':
        return '10';
      case '6.3':
        return '8.1';
      case '6.2':
        return '8';
      case '6.1':
        return '7';
      case '6.0':
        return 'Vista';
      case '5.2':
      case '5.1':
        return 'XP';
      case '5.0':
        return '2000';
      default:
        return UNKNOWN;
      }

    },

    /**
     * Return a version number for an mac os device
     * @return   {string} The version number
     * @author Bruno Sabot
     */
    mac: function () {

      var version = /Mac OS.* ([0-9_]+)/i.exec(navigator.userAgent);
      if (version[1]) {
        return version[1].split('_').slice(0, 2).join('.');
      } else {
        return UNKNOWN;
      }

    }

  };

  /**
   * Specific function to parse the browser version
   * @namespace
   * @memberof w.Class.UserAgentManager
   */
  var browserVersion = {

    /**
     * Return a version number for a Chrome browser
     * @return {int} The version number
     * @author Bruno Sabot
     */
    chrome: function () {

      return parseInt((/Chrome\/([0-9]+)/.exec(navigator.userAgent) || ['', UNKNOWN])[1]);

    },

    /**
     * Return a version number for a Firefox browser
     * @return {int} The version number
     * @author Bruno Sabot
     */
    firefox: function () {

      return parseInt((/Firefox\/([0-9]+)/.exec(navigator.userAgent) || ['', UNKNOWN])[1]);

    },

    /**
     * Return a version number for an Internet Explorer browser
     * @return   {int} The version number
     * @author Bruno Sabot
     */
    ie: function () {

      var version = (/rv\:([0-9]+)/.exec(navigator.userAgent) || ['', UNKNOWN])[1];

      if (version === UNKNOWN) {
        version = (/IEMobile\/([0-9]+)/.exec(navigator.userAgent) || ['', UNKNOWN])[1];
      }

      if (version === UNKNOWN) {
        version = (/MSIE\s([0-9]+)/.exec(navigator.userAgent) || ['', UNKNOWN])[1];
      }

      return parseInt(version, 10);

    },

    /**
     * Return a version number for an edge browser
     * @return   {int} The version number
     * @author Bruno Sabot
     */
    edge: function () {

      var version = (/Edge\/([0-9]+)\./.exec(navigator.userAgent) || ['', UNKNOWN])[1];

      return parseInt(version, 10);

    },

    /**
     * Return a version number for a Safari browser
     * @return {int} The version number
     * @author Bruno Sabot
     */
    safari: function () {

      return parseFloat((/Version\/([0-9]+\.[0-9]+)/.exec(navigator.userAgent) || ['', UNKNOWN])[1]);

    }

  };

  /**
   * Associate matched string to a browser, an os, an os version and a device type
   * @author Bruno Sabot
   * @private
   * @memberof w.Class.UserAgentManager
   */
  var constructObject = function () {

    var width = Math.max(w.Param.viewBody.getBoundingClientRect().width, w.Param.viewBody.getBoundingClientRect().height);

    // iOS
    // IE cheat and says it's iphone
    if ((toFindPos.iphone || toFindPos.ipad) && !toFindPos.trident) {

      this.os.name = OS.IOS;
      this.device.type = FORMAT.TABLET;
      this.browser.name = BROWSER.SAFARI;

      if (toFindPos.iphone) {
        this.device.type = FORMAT.PHONE;

        if (width > 750 && !toFindPos.safari) {
          this.device.type = FORMAT.TABLET;
        }

      } else if (width < 750) {
        this.device.type = FORMAT.PHABLET;
      }

      return;

    }

    // mac OS
    // IE cheat and says it's mac os
    if (toFindPos['mac os'] && !toFindPos.trident) {

      this.os.name = OS.MAC;
      this.device.type = FORMAT.DESKTOP;

      if (toFindPos.chrome) {
        this.browser.name = BROWSER.CHROME;
      } else if (toFindPos.firefox) {
        this.browser.name = BROWSER.FIREFOX;
      } else {
        this.browser.name = BROWSER.SAFARI;
      }

      return;

    }

    // Windows
    if (toFindPos.windows) {

      this.os.name = OS.WINDOWS;

      if (toFindPos.edge) {
        this.os.name = OS.WINDOWS;
        this.browser.name = BROWSER.EDGE;
      } else if (toFindPos.chrome) {
        this.browser.name = BROWSER.CHROME;
      } else if (toFindPos.firefox) {
        this.browser.name = BROWSER.FIREFOX;
      } else {
        this.browser.name = BROWSER.IE;
      }

      if (toFindPos.mobile || toFindPos.phone) {
        this.device.type = FORMAT.PHONE;
      } else {
        this.device.type = FORMAT.DESKTOP;
      }

    }

    // linux
    if (toFindPos.linux) {

      this.os.name = OS.LINUX;

      if (toFindPos.chrome) {
        this.browser.name = BROWSER.CHROME;
      } else if (toFindPos.firefox) {
        this.browser.name = BROWSER.FIREFOX;
      }

      this.device.type = FORMAT.DESKTOP;

    }

    // Tizen
    if (toFindPos.tizen) {

      this.os.name = OS.TIZEN;
      this.browser.name = BROWSER.TIZEN;

      return;

    }

    // Blackberry
    if (toFindPos.blackberry) {

      this.os.name = OS.BLACKBERRY;
      this.browser.name = BROWSER.BLACKBERRY;

      return;

    }

    // Android
    // IE cheat and says it's android
    if (toFindPos.android && !toFindPos.trident) {

      this.os.name = OS.ANDROID;
      this.device.type = FORMAT.TABLET;

      if (toFindPos.chrome) {
        this.browser.name = BROWSER.CHROME;
      } else if (toFindPos.firefox) {
        this.browser.name = BROWSER.FIREFOX;
      } else {
        this.browser.name = BROWSER.ANDROID;
      }

      // Firefox
    } else if (toFindPos.firefox && (toFindPos.mobile || toFindPos.tablet)) {
      this.os.name = OS.FIREFOX;
      this.browser.name = BROWSER.FIREFOX;
    }

    // Check format
    if (toFindPos.mobile) {
      this.device.type = FORMAT.PHONE;
    } else if (this.device.type !== FORMAT.DESKTOP) {

      if (width / window.devicePixelRatio < 750) {
        this.device.type = FORMAT.PHABLET;
      } else if (width / window.devicePixelRatio <= 1280) {
        this.device.type = FORMAT.TABLET;
      } else {
        this.device.type = FORMAT.DESKTOP;
      }

    }

  };

  /**
   * Get an object with information on the current browser, browser version, os, os version and device type
   * @author Bruno Sabot
   * @class
   * @memberof w.Class
   * @example
   * // Create the object and analyse the current user agent to retrieve some information about
   * var userAgentManager = new UserAgentManager();
   *
   * var myOsName = userAgentManager.os.name // "android", "iOS", "blackberry", "firefox" or "tizen"
   * var myOsVersion = userAgentManager.os.version // equal 6 or 7 for example
   * var myDeviceType = userAgentManager.device.type // "phone" or "tab"
   * var myBrowserName = userAgentManager.browser.name // "safari", "chrome", "firefox", "android", "tizen", "blackberry"
   * @property {string} os.name current os name (android/iOS/...)
   * @property {integer} os.version current os version
   * @property {string} browser.name current browser (Safari/Chrome/android/...)
   * @property {string} browser.version current browser version
   * @property {string} device.type current device type (phone/tab)
   */
  function UserAgentManager() {

    this.os = {
      "name": UNKNOWN,
      "version": UNKNOWN
    };
    this.device = {
      "type": UNKNOWN
    };
    this.browser = {
      "name": UNKNOWN,
      "version": UNKNOWN
    };

    // Check basic part
    constructObject.call(this);

    // Check OS version
    if (osVersion[this.os.name]) {
      this.os.version = osVersion[this.os.name]();
    }

    // Check browser version
    if (browserVersion[this.browser.name]) {
      this.browser.version = browserVersion[this.browser.name]();
    }

  }

  /**
   * Return true if the device is a desktop
   * @return {boolean} True if the device is a desktop
   * @example
   * if (userAgent.isDesktop() === true) {
   *   alert("I'm a computer")
   * }
   * @author Alessandro Cipolletti
   */
  UserAgentManager.prototype.isDesktop = function () {
    return this.device.type === FORMAT.DESKTOP;
  };

  /**
   * Return true if the device is a phone
   * @return {boolean} True if the device is a phone
   * @example
   * if (userAgent.isPhone() === true) {
   *   alert("I'm a phone")
   * }
   * @author Bruno Sabot
   */
  UserAgentManager.prototype.isPhone = function () {
    return this.device.type === FORMAT.PHONE;
  };

  /**
   * Return true if the device is a tablet
   * @return {boolean} True if the device is a tablet
   * @example
   * if (userAgent.isTablet() === true) {
   *   alert("I'm a tablet")
   * }
   * @author Bruno Sabot
   */
  UserAgentManager.prototype.isTablet = function () {
    return this.device.type === FORMAT.TABLET || this.device.type === FORMAT.PHABLET;
  };

  /**
   * Return true if the device is a phablet
   * @return {boolean} True if the device is a phablet
   * @example
   * if (userAgent.isPhablet() === true) {
   *   alert("I'm a small tablet... or a big phone")
   * }
   * @author Bruno Sabot
   */
  UserAgentManager.prototype.isPhablet = function () {
    return this.device.type === FORMAT.PHABLET;
  };

  /**
   * Return true if the device is not identified
   * @return {boolean} True if the device is not identified
   * @example
   * if (userAgent.isUnknown() === true) {
   *   alert("I don't know who I am :'(")
   * }
   * @author Bruno Sabot
   */
  UserAgentManager.prototype.isUnknown = function () {
    return this.device.type === UNKNOWN;
  };

  /**
   * Return true if the browser is IE
   * @return {boolean} True if the browser is IE
   * @example
   * if (userAgent.isIE() === true) {
   *   alert("I am IE. And I need to switch to Edge!")
   * }
   * @author Bruno Sabot
   */
  UserAgentManager.prototype.isIE = function () {
    return this.browser.name === BROWSER.IE;
  };

  /**
   * OS type list
   * @type {Object}
   * @property {string} IOS Static string that define the iOS OS
   * @property {string} ANDROID Static string that define an Android OS
   * @property {string} BLACKBERRY Static string that define the Blackberry OS
   * @property {string} FIREFOX Static string that define the Firefox OS
   * @property {string} TIZEN Static string that define the Tizen OS
   * @property {string} WINDOWS Static string that define a Windows OS
   * @property {string} MAC Static string that define a Mac OS
   * @author Bruno Sabot
   */
  UserAgentManager.prototype.OS = OS;

  /**
   * Browsers type list
   * @type {Object}
   * @property {string} SAFARI Static string that define Safari
   * @property {string} CHROME Static string that define Google Chrome
   * @property {string} FIREFOX Static string that define Mozilla Firefox
   * @property {string} ANDROID Static string that define the old Android browser
   * @property {string} TIZEN Static string that define Tizen
   * @property {string} BLACKBERRY Static string that define the Blackberry browser
   * @property {string} IE Static string that define Internet Explorer
   * @property {string} EDGE       Static string that define Edge
   * @author Bruno Sabot
   */
  UserAgentManager.prototype.BROWSER = BROWSER;

  /**
   * Format type list
   * @type {Object}
   * @property {string} PHABLET Static string that define a phablet
   * @property {string} TABLET Static string that define a tablet
   * @property {string} PHONE Static string that define a phone
   * @property {string} DESKTOP Static string that define a desktop
   * @author Bruno Sabot
   */
  UserAgentManager.prototype.FORMAT = FORMAT;

  /**
   * Unknown type
   * @author Bruno Sabot
   * @type {String}
   */
  UserAgentManager.prototype.UNKNOWN = UNKNOWN;

  w.Class.UserAgentManager = UserAgentManager;

})(webpublicationNamespace);

(function (w) {

  /**
   * The template compiled function cache
   * @type {Object}
   * @private
   * @memberof w.Class.TemplateManager
   * @author Bruno Sabot
   */
  var cache = {};

  /**
   * List of core template function
   * @namespace
   * @private
   * @memberof w.Class.TemplateManager
   */
  var templateCore = {

    /**
     * Remove comments
     * @param  {String} str The template as a string
     * @return {String} The updated string
     * @author Bruno Sabot
     */
    _comments: function (str) {

      return str.replace(/<\!\-\-[^>]*\-\-\>/gmi, '');

    },

    /**
     * Enable the {{default}} tag.
     * @example
     * {{default(variableDefault, 'variable value')}}
     * {{default(variableDefault, otherVariable)}}
     * @param  {String} str The template as a string
     * @return {String} The updated string
     * @author Bruno Sabot
     */
    _default: function (str) {

      return str.replace(/\{\{default\((.*?),\s*(.*?)\)\}\}/g, function (matched, m1, m2) {
        return '<% if ( typeof( ' + m1 + ' ) === "undefined" ) { var ' + m1 + ' = ' + m2 + ' } %>';
      });

    },

    /**
     * Enable the {{exists}} tag.
     * @example
     * {{exists variableName}}
     *   It exists
     * {{otherwise}}
     *   It does not exist
     * {{/exists}}
     * @param  {String} str The template as a string
     * @return {String} The updated string
     * @author Bruno Sabot
     */
    _exists: function (str) {

      return str
        .replace(/\{\{\s*exists\s*(.*?)\s*\}\}/g, function (matched, m1) {
          return '<% if ( typeof( ' + m1 + ') !== "undefined" ) {  %>';
        })
        .replace(/\{\{\s*otherwise\s*\}\}/g, function () {
          return '<% } else { %>';
        })
        .replace(/\{\{\s*\/exists\s*\}\}/g, '<% } %>');

    },

    /**
     * Enable the {{if}} tag.
     * @example
     * {{if variableName}}
     *   If case
     * {{else}}
     *   Else case
     * {{/if}}
     *
     * {{if variableName}}
     *   If case
     * {{/if}}
     * @param  {String} str The template as a string
     * @return {String} The updated string
     * @author Bruno Sabot
     */
    _if: function (str) {

      return str
        .replace(/\{\{\s*(else|if)(.*?)\s*\}\}/g, function (matched, m1, m2) {

          if (m1 === 'if') {
            return '<% if(' + m2 + ') { %>';
          } else if (m2 === '' && m1 === 'else') {
            return '<% } else { %>';
          } else if (m1 === 'else') {
            return '<% } else if(' + m2 + ') { %>';
          }

        })
        .replace(/\{\{\s*\/if\s*\}\}/g, '<% } %>');

    },

    /**
     * Enable the {{each}} tag.
     * @example
     * {{each(i,item) items}}
     *   {{item.value}}
     * {{/each}}
     * @param  {String} str The template as a string
     * @return {String} The updated string
     * @author Bruno Sabot
     */
    _each: function (str) {

      return str
        .replace(/\{\{\s*each\((.*?),(.*?)\)\s*(.*?)\s*\}\}/g, function (matched, m1, m2, m3) {
          return '<% for(var ' + m1 + ' in ' + m3 + ') { if(' + m3 + ' instanceof Array) {' + m1 +
            ' = parseInt(' + m1 + ', 10);} var ' + m2 + ' = ' + m3 + '[' + m1 + ']; %>';
        })
        .replace(/\{\{\s*\/each\s*\}\}/g, '<% } %>');

    },

    /**
     * On IE, method seems not to work with the "with" keyword
     * @param  {String} str The template as a string
     * @return {String} The updated string
     * @author Bruno Sabot
     */
    _webpublicationNamespace: function (str) {

      return str.replace(/([^a-zA-Z0-9])w\./gi, "$1webpublicationNamespace.");

    },

    /**
     * On IE, method seems not to work with the "with" keyword
     * @param  {String} str The template as a string
     * @return {String} The updated string
     * @author Bruno Sabot
     */
    _ie: function (str) {

      return str.replace(/([0-9a-z_]+)Plugin/gi, "obj.$1Plugin");

    },

    /**
     * Enable the simple display of a variable
     * the _var MUST be the last to be executed
     * @example
     * {{variableName}}
     * @param  {String} str The template as a string
     * @return {String} The updated string
     * @author Bruno Sabot
     */
    _var: function (str) {

      str = str.replace(/(\r\n|\n|\r)/gm, " ");
      return str.replace(/\{\{(.*?)\}\}/g, '<%=$1%>').replace(/\s+/g, " ");

    }

  };

  /**
   * List of template plugin functions
   * @namespace
   * @private
   * @memberof w.Class.TemplateManager
   */
  var templatePlugins = {};

  /**
   * List of template component functions
   * @namespace
   * @private
   * @memberof w.Class.TemplateManager
   */
  var templateComponents = {};

  /**
   * List of template callbacks functions
   * @namespace
   * @private
   * @memberof w.Class.TemplateManager
   */
  var templateCallbacks = {

    /**
     * Parse icons to include svg and change the color
     * @param  {DOMElement} tpl The template
     * @author Bruno Sabot
     */
    icons: function (tpl) {

      var svgicon = tpl.querySelectorAll('.svgicon svg');
      var svgiconLength = svgicon.length;

      while (svgiconLength--) {

        if (svgicon[svgiconLength].getAttribute('data-color')) {

          w.Utils.svgIcon(svgicon[svgiconLength], {
            "icon": svgicon[svgiconLength].getAttribute('data-icon'),
            "color": svgicon[svgiconLength].getAttribute('data-color')
          });

        }

      }

    },

    /**
     * Add the focusable capacity to an element
     * @param  {DOMElement} tpl The template
     * @author Bruno Sabot
     * @function
     */
    focusable: function () {

      var focusClickCallback = function (event) {
        var elem = event.target;
        var closestFocusable = w.Utils.getClosestByClass(elem, 'focusable');

        if (closestFocusable !== false) {
          closestFocusable.classList.add('focused');
          window.setTimeout(function () {
            closestFocusable.classList.remove('focused');
          }, 300);
        }

      };

      return function (tpl) {

        var focusable = tpl.querySelectorAll('.focusable');
        var focusableLength = focusable.length;

        while (focusableLength--) {
          focusable[focusableLength].addEventListener('vclick', focusClickCallback);
        }

      };

    }(),

    /**
     * Include a subtemplate in the document
     * @param  {DOMElement} tpl The template
     * @author Bruno Sabot
     */
    template: function () {

      var parsePage = function (element, template, data) {

        return execute(w.Utils.getTemplate('component', template), data).then(function (t) {

          var tLength = t.length;
          var parentNode = element.parentNode;

          for (var j = 0; j < tLength; j++) {

            if (templateComponents[template]) {
              templateComponents[template].call(t[j], data, template);
            }

            if (parentNode !== null && t[j]) {
              parentNode.insertBefore(t[j], element);
            } else if (t[j]) {
              element = t[j];
            }

            // Timeout 10ms for Edge. 0s is enought on others
            window.setTimeout(function () {
              if (this.onTemplateInserted) {
                this.onTemplateInserted();
              }
            }.bind(t[j]), 10);

          }

          if (parentNode !== null) {
            parentNode.removeChild(element);
          }

        });

      };

      return function (tpl) {

        var tpls = tpl.querySelectorAll('.templateManagerPlaceholder');
        var promises = [];

        for (var i = 0; i < tpls.length; i++) {

          if (tpls[i].parentNode !== null) {

            var template = tpls[i].getAttribute('data-template');
            var data = JSON.parse(tpls[i].getAttribute('data-data'));

            var promise = w.require(['js/component/' + template, 'css/component/' + template])
              .then(parsePage.bind(this, tpls[i], template, data));

            promises.push(promise);

          }

        }

        return Promise.all(promises);

      };

    }()

  };

  /**
   * Append a template to a content
   * @param {DOMArray}   tpl    The templates to include
   * @param {DOMElement} target The target template
   * @author Bruno Sabot
   * @memberof w.Class.TemplateManager
   * @private
   */
  var appendTo = function (tpl, target) {

    var innerScript = [];
    var loadCallbackCounter = 0;
    var loadCallback = function () {

      if (--loadCallbackCounter <= 0) {

        for (var i = 0; i < innerScript.length; i++) {

          var script = document.createElement('script');
          script.type = 'text/javascript';
          script.innerHTML = innerScript[i];
          target.appendChild(script);

        }

      }

    };
    var createScript = function (templateScript) {

      if (templateScript.src) {

        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = templateScript.src;
        script.onload = loadCallback;
        loadCallbackCounter++;
        target.appendChild(script);

      } else {
        innerScript.push(templateScript.innerHTML);
      }

      templateScript.outerHTML = '';

    };
    var createLink = function (templateLink) {

      var link = document.createElement('link');
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('type', 'text/css');
      link.href = templateLink.href;
      target.appendChild(link);

      templateLink.outerHTML = '';

    };

    var tplLength = tpl.length;
    for (var i = 0; i < tplLength; i++) {

      if (tpl[i].getElementsByTagName) {

        // Children scripts
        var scripts = tpl[i].getElementsByTagName('script');

        for (var j = 0; j < scripts.length; j++) {
          createScript(scripts[j]);
        }

        if (tpl[i].tagName === 'SCRIPT') {
          createScript(tpl[i]);
        }

        // Children links
        var links = tpl[i].getElementsByTagName('link');
        for (var k = 0; k < links.length; k++) {
          createLink(links[k]);
        }

        if (tpl[i].tagName === 'LINK') {
          createLink(tpl[i]);
        }

      }

      target.appendChild(tpl[i]);

      // Timeout 10ms for Edge. 0s is enought on others
      window.setTimeout(function () {
        if (this.onTemplateInserted) {
          this.onTemplateInserted();
        }
      }.bind(tpl[i]), 10);

    }

    return tpl;

  };

  /**
   * Compile a template to a JavaScript function
   * @param  {String}   str The template as a string
   * @return {Function}     The compiled JavaScript function associated to the string
   * @author Bruno Sabot
   * @memberof w.Class.TemplateManager
   * @private
   */
  var compile = function (str) {

    for (var i in templateCore) {
      str = templateCore[i](str);
    }

    // Generate a reusable function that will serve as a template
    // generator (and which will be cached).
    /*jslint evil: true */
    return new Function("obj",
      "var w=webpublicationNamespace;" +
      "var p=[];" +

      // Introduce the data as local variables using with(){}
      "with(obj){p.push('" +

      str.replace(/[\r\t\n]/g, " ")
      .replace(/'(?=[^%]*%>)/g, "\t")
      .split("'").join("\\'")
      .split("\t").join("'")
      .replace(/<%=(.+?)%>/g, "',$1,'")
      .split("<%").join("');")
      .split("%>").join("p.push('") + "');}return p.join('');");

  };

  /**
   * Execute the JavaScript template function to get an array of DOM elements
   * @param  {String}    key    The template file name
   * @param  {Object}    data   The template parameters
   * @param  {DOMObject} target The target where the template is going to be inserted
   * @return {Promise}          A promise object that match the execution
   * @author Bruno Sabot
   * @memberof w.Class.TemplateManager
   * @private
   */
  var execute = function (key, data, target) {

    data = data || {};

    if (w.Utils.getFunctionName(data.constructor) === "String") {
      data = {
        "content": data
      };
    }

    for (var i in templatePlugins) {
      data[i + 'Plugin'] = templatePlugins[i];
    }

    return Promise.resolve(loadFile(key))
      .then(parse.bind(this, key, data, target));

  };

  /**
   * Load and compile a template file
   * @param {String} url The template URL
   * @author Bruno Sabot
   * @memberof w.Class.TemplateManager
   * @private
   */
  var loadFile = function (url) {

    if (typeof (cache[url]) === 'undefined') {
      cache[url] = w.require(url).then(function (xhr) {
        return Promise.resolve(compile(xhr.responseText));
      });
    }

    return cache[url];

  };

  /**
   * Parse template to find template plugins
   * @param  {String}    key    The template file name
   * @param  {Object}    data   The template parameters
   * @param  {DOMObject} target The target where the template is going to be inserted
   * @return {Promise}          A promise object that match the parsing
   * @author Bruno Sabot
   * @memberof w.Class.TemplateManager
   * @private
   */
  var parse = function (key, data, target, templateMethod) {

    var tag = 'div';
    if (data && data.useTr === true) {
      tag = 'table';
    }

    var doc = document.createElement(tag);
    doc.id = 'tmplWrapper';
    doc.innerHTML = templateMethod(data);

    if (tag === 'table') {
      doc = doc.getElementsByTagName('tr')[0].parentNode;
    }

    var promises = [];

    // We call template plugins only on the supported version
    if (doc.querySelectorAll) {

      for (var j in templateCallbacks) {
        promises.push(templateCallbacks[j](doc, target));
      }

    }

    return Promise.all(promises).then(function () {

      var childNodes = [];
      var childNodesLength = doc.childNodes.length;

      var component = false;
      if (key.indexOf('component') !== -1) {

        component = key.replace('.html', '').split('/');
        component = component[component.length - 1];

      }

      while (childNodesLength--) {

        var currentNode = doc.childNodes[childNodesLength];
        if (currentNode.nodeType !== 3 || currentNode.textContent.trim() !== "") {
          childNodes.unshift(currentNode);
        }

      }

      return Promise.resolve(childNodes);

    });

  };

  /**
   * Prepend a template before a content
   * @param {DOMArray}   tpl    The templates to include
   * @param {DOMElement} target The target template
   * @author Bruno Sabot
   * @memberof w.Class.TemplateManager
   * @private
   */
  var prependBefore = function (tpl, target) {

    var tplLength = tpl.length;
    while (tplLength--) {

      target.parentNode.insertBefore(tpl[tplLength], target);

      // Timeout 10ms for Edge. 0s is enought on others
      window.setTimeout(function () {
        if (this.onTemplateInserted) {
          this.onTemplateInserted();
        }
      }.bind(tpl[tplLength]), 10);

    }

    return tpl;

  };

  /**
   * Prepend a template to a content
   * @param {DOMArray}   tpl    The templates to include
   * @param {DOMElement} target The target template
   * @author Bruno Sabot
   * @memberof w.Class.TemplateManager
   * @private
   */
  var prependTo = function (tpl, target) {

    var tplLength = tpl.length;
    while (tplLength--) {

      target.insertBefore(tpl[tplLength], target.firstChild);

      // Timeout 10ms for Edge. 0s is enought on others
      window.setTimeout(function () {
        if (this.onTemplateInserted) {
          this.onTemplateInserted();
        }
      }.bind(tpl[tplLength]), 10);

    }

    return tpl;

  };

  /**
   * Replace a template by another
   * @param  {DOMArray}   tpl    The templates to include
   * @param  {DOMElement} target The target template
   * @author Bruno Sabot
   * @memberof w.Class.TemplateManager
   * @private
   */
  var replaceTo = function (tpl, target) {

    var finalTarget = null;
    if (target instanceof Node) {
      finalTarget = target;
    } else {
      finalTarget = target[0];
    }

    for (var i = 0; i < tpl.length; i++) {
      finalTarget.parentNode.insertBefore(tpl[i], finalTarget);

      // Timeout 10ms for Edge. 0s is enought on others
      window.setTimeout(function () {
        if (this.onTemplateInserted) {
          this.onTemplateInserted();
        }
      }.bind(tpl[i]), 10);

    }

    if (target instanceof Node) {
      target.parentNode.removeChild(target);
    } else {
      for (var j = 0; j < target.length; j++) {
        target[j].parentNode.removeChild(target[j]);
      }
    }

    return tpl;

  };

  /**
   * Handle templates
   * @author Bruno Sabot
   * @class
   * @memberof w.Class
   */
  function TemplateManager() {}

  /**
   * Add a callback to the template manager
   * @param {String}   name     The callback name. Has to be unique
   * @param {Function} callback The callback to execute. get the template as parameters (DOMElement)
   * @author Bruno Sabot
   * @static
   */
  TemplateManager.addCallback = function (name, callback) {

    templateCallbacks[name] = callback;

  };

  /**
   * Add a component to the template manager
   * @param {String}   name     The component name. Has to be unique
   * @param {Function} callback The component code
   * @author Bruno Sabot
   * @static
   */
  TemplateManager.addComponent = function (name, callback) {

    templateComponents[name] = callback;

  };

  /**
   * Add plugin to the template manager
   * @param {String}   name     The plugin name. Has to be unique
   * @param {Function} callback The plugin code
   * @author Bruno Sabot
   * @static
   */
  TemplateManager.addPlugin = function (name, callback) {

    templatePlugins[name] = callback;

  };

  /**
   * Return the plugin list. DEV ONLY
   * @return Object The plugin list
   * @author Bruno Sabot
   */
  TemplateManager.getPlugin = function () {

    return templatePlugins;

  };

  /**
   * Return the plugin list. DEV ONLY
   * @return Object The plugin list
   * @author Bruno Sabot
   */
  TemplateManager.getComponentScript = function () {

    return templateComponents;

  };

  /**
   * Get the template cache. DEV ONLY
   * @return Object The compilated templates
   */
  TemplateManager.getCache = function () {
    return cache;
  };

  /**
   * Load a template content directly into a DOMElement
   * @param  {String}     templateUrl The template URL
   * @param  {DOMElement} target      The target DOMElement
   * @param  {Object}     data        The template parameters
   * @return {Promise}                A promise object
   * @author Bruno Sabot
   */
  TemplateManager.prototype.load = function (templateUrl, target, data) {

    return execute(templateUrl, data, target).then(function (tpl) {
      return appendTo(tpl, target);
    });

  };

  /**
   * Load a template content directly at the start of a DOMElement
   * @param  {String}     templateUrl The template URL
   * @param  {DOMElement} target      The target DOMElement
   * @param  {Object}     data        The template parameters
   * @return {Promise}                A promise object
   * @author Bruno Sabot
   */
  TemplateManager.prototype.loadPrepend = function (templateUrl, target, data) {

    return execute(templateUrl, data, target).then(function (tpl) {
      return prependTo(tpl, target);
    });

  };

  /**
   * Load a template content directly at the start of a DOMElement
   * @param  {String}     templateUrl The template URL
   * @param  {DOMElement} target      The target DOMElement
   * @param  {Object}     data        The template parameters
   * @return {Promise}                A promise object
   * @author Bruno Sabot
   */
  TemplateManager.prototype.loadBefore = function (templateUrl, target, data) {

    return execute(templateUrl, data, target).then(function (tpl) {
      return prependBefore(tpl, target);
    });

  };

  /**
   * Load a template content to replace a DOMElement
   * @param  {String}     templateUrl The template URL
   * @param  {DOMElement} target      The target DOMElement
   * @param  {Object}     data        The template parameters
   * @return {Promise}                A promise object
   * @author Bruno Sabot
   */
  TemplateManager.prototype.loadReplace = function (templateUrl, target, data) {

    return execute(templateUrl, data, target).then(function (tpl) {
      return replaceTo(tpl, target);
    });

  };

  w.Class.TemplateManager = TemplateManager;

  w.Class.TemplateManager.addPlugin('escape',
    /**
     * Correctly escape the ' char
     * @param  {String} value The value to escape
     * @return {String} The updated value
     * @author Bruno Sabot
     * @memberof w.Class.TemplateManager.templatePlugins
     * @function escapePlugin
     */
    function (value) {

      if (value) {
        return value.replace('\'', '\\\'');
      }

    }
  );

  w.Class.TemplateManager.addPlugin("locale",
    /**
     * Returns translate text
     * @param {String} key The key corresponding to text to translate
     * @author Alessandro Cipolletti
     * @memberof Class.TemplateManager.templatePlugins
     * @function localePlugin
     */
    function (key) {
      return w.Utils.prodTools.getWordLangueByIndex(key);
    }

  );

  w.Class.TemplateManager.addPlugin('icon',
    /**
     * Add a svg icon in the document
     * @param  {String} icon      The icon to show
     * @param  {String} className An additionnal classname
     * @param  {String} color     The icon color
     * @return {String}           The associated html code
     * @author Bruno Sabot
     * @memberof w.Class.TemplateManager.templatePlugins
     * @function iconPlugin
     */
    function (icon, classe, color) {

      var container = document.createElement("div");
      container.className = "svgicon-new svgicon-" + icon + " " + classe;

      w.Utils.svgIcon(container, {
        "icon": icon,
        "color": color || null
      });

      return container.outerHTML;

    }
  );

  w.Class.TemplateManager.addPlugin('encode',
    /**
     * Encode as an URL a string
     * @param  {String} string The string to encode
     * @return {String}        The string encoded
     * @author Bruno Sabot
     * @memberof w.Class.TemplateManager.templatePlugins
     * @function encodePlugin
     */
    function (string) {

      if (isNaN(string)) {
        return encodeURIComponent(string);
      }

    }
  );

  w.Class.TemplateManager.addPlugin('template',
    /**
     * Include a subtemplate
     * @param  {String} template The template name
     * @param  {Object} data     The template data
     * @return {String}          A div corresponding to the template
     * @author Bruno Sabot
     * @memberof w.Class.TemplateManager.templatePlugins
     * @function templatePlugin
     */
    function (template, data) {

      var tag = 'div';
      if (data && data.useTr === true) {
        tag = 'tr';
      }

      if (data) {
        data = JSON.stringify(data).replace(/"/g, '&quot;').replace(/\{/g, '&#123;').replace(/\}/g, '&#125;');
      } else {
        data = '{}';
      }

      return '<' + tag + ' class="templateManagerPlaceholder" data-template="' + template + '" data-data="' + data +
        '"></' + tag + '>';

    }
  );

})(webpublicationNamespace);

(function (w) {

  var _transferringNames = [];
  var _originalTransferring;
  var _xmlVariables;

  /**
   * Handle page data
   * @constructs TransferringManager
   * @memberof Class
   * @author Bruno Sabot
   */
  function TransferringManager() {}

  TransferringManager.prototype.execute = function (dom, xmlVariables) {

    _xmlVariables = xmlVariables;
    _originalTransferring = w.Main.xmlManager.getVariable('transferring');

    if (typeof (_originalTransferring) === "undefined") {
      return Promise.resolve();
    }

    var query = new w.Class.QueryManager();
    var proxy = dom.querySelector('proxy');
    if (proxy) {

      return query.execute(proxy)
        .then(function (transferring) {
          _xmlVariables.transferring = transferring;
          return Promise.resolve(transferring);
        })
        .then(query.execute.bind({}, dom))
        .then(this.parseData);

    }

    return query.execute(dom)
      .then(this.parseData);

  };

  TransferringManager.prototype.parseData = function () {

    function toGlobalVariable(prefix, data) {

      for (var i in data) {

        if (typeof (data[i]) === 'object' && (data[i] instanceof Array) === false) {
          toGlobalVariable(prefix + '_' + i, data[i]);
        } else {
          _xmlVariables[prefix + '_' + i] = data[i];
          _transferringNames.push(prefix + '_' + i);
        }

      }

    }

    return function (json) {
      toGlobalVariable('transferring', json);
      _xmlVariables.transferring = _originalTransferring;
      return Promise.resolve();
    };

  }();

  TransferringManager.prototype.remove = function () {

    if (localStorage) {
      localStorage.removeItem('transferring');
    }

    for (var i in _xmlVariables) {
      if (i.indexOf('transferring') === 0) {
        delete _xmlVariables[i];
      }
    }

    return w.Main.urlManager["delete"]('transferring');

  };

  w.Class.TransferringManager = TransferringManager;

})(webpublicationNamespace);

(function (w) {

  function _CSVToJSON(inputData, delimiter) {

    var CSVRegex = new RegExp((
      "(\\" + delimiter + "|\\r?\\n|\\r|^)" + // Delimiters.
      "(?:\"([^\"]*(?:\"\"[^\"]*)*)\"|" + // Quoted fields.
      "([^\"\\" + delimiter + "\\r\\n]*))" // Standard fields.
    ), "gi");
    var data = [];
    var columnNames = [];
    var columnDone = false;
    var currentIndex = 0;
    var matches = null;

    while ((matches = CSVRegex.exec(inputData)) !== null) {

      var strMatchedDelimiter = matches[1];
      if (strMatchedDelimiter.length && strMatchedDelimiter !== delimiter) {
        data.push({});
        columnDone = true;
        currentIndex = 0;
      }

      var strMatchedValue;
      if (matches[2]) {
        strMatchedValue = matches[2].replace(new RegExp("\"\"", "g"), "\"");
      } else {
        strMatchedValue = matches[3];
      }

      if (columnDone === false) {
        columnNames.push(strMatchedValue);
      } else {
        data[data.length - 1][columnNames[currentIndex]] = strMatchedValue;
      }

      currentIndex++;

    }

    return (data);

  }

  function _CSV(datasetTag, data) {

    var CSVData = _CSVToJSON(data.trim(), datasetTag.getAttribute('separator') || ',');
    var matchingProp = datasetTag.querySelector('matchingProp');
    if (matchingProp) {

      var transferringValue = w.Main.xmlManager.getVariable('transferring') || w.Main.urlManager.get('transferring');
      return CSVData.filter(function (item) {
        return item[matchingProp.getAttribute('id')] === transferringValue;
      })[0];

    }

    return CSVData;

  }

  function _JSON(datasetTag, data) {

    var JSONData = JSON.parse(data);
    var matchingProp = datasetTag.querySelector('matchingProp');
    if (matchingProp) {
      return JSONData[matchingProp.getAttribute('id')];
    }

    return JSONData;

  }

  /**
   * Handle page data
   * @constructs QueryManager
   * @memberof Class
   * @author Bruno Sabot
   */
  function QueryManager() {}

  QueryManager.prototype.execute = function (dom) {

    var datasetTag = Array.prototype.filter.call(dom.childNodes, function (item) {
      return item.nodeName === 'dataset';
    })[0];
    var urlTag = Array.prototype.filter.call(dom.childNodes, function (item) {
      return item.nodeName === 'url';
    })[0];
    var assetTag = Array.prototype.filter.call(dom.childNodes, function (item) {
      return item.nodeName === 'asset';
    })[0];

    var datasetType = datasetTag.getAttribute('type');

    var url;
    if (urlTag) {
      url = urlTag.textContent;
    } else if (assetTag) {
      url = w.Main.xmlManager.get("common-ui", "assets", assetTag.getAttribute("id"));
      url = url.hasOwnProperty("url") ? url.url : url;
    }

    var headers = [];
    if (urlTag && urlTag.hasAttribute && urlTag.hasAttribute('username') && urlTag.hasAttribute('password')) {
      headers.push({
        "key": "Authorization",
        "username": urlTag.getAttribute("username"),
        "password": urlTag.getAttribute("password")
      });
    }

    return w.Utils.promiseXHR('GET', w.Utils.resolveVariable(url), headers).then(function (xhr) {

      var data = null;
      if (datasetType === 'JSON') {
        data = _JSON(datasetTag, xhr.responseText);
      } else if (datasetType === 'CSV') {
        data = _CSV(datasetTag, xhr.responseText);
      }

      return Promise.resolve(data);

    });

  };

  w.Class.QueryManager = QueryManager;

})(webpublicationNamespace);

(function (w) {

  /**
   * The XML variable associative array
   * @type {Object}
   * @private
   */
  var xmlVariables = {};

  /**
   * The XML document list
   * @type {Object}
   * @private
   */
  var xmlDocuments = {};

  /**
   * The XML content data
   * @type {Object}
   * @namespace
   * @private
   */
  var xmlData = {

    /**
     * The pubinfo.xml data content
     * @type {Object}
     * @property {String}   template The template.xml file URL
     * @property {String}   contents The contents.xml file URL
     * @property {function} get      Get full informations for a specified type
     */
    "pubinfo": {},

    /**
     * The contents.xml data content
     * @type {Object}
     * @property {object}   config  The pages global configuration
     * @property {object}   content The page content information for each type
     * @property {function} get     Get full informations for a specified type
     */
    "contents": {},

    /**
     * The template.xml data content
     * @type {Object}
     * @property {object}   configs.preloader The flash preloader informations
     * @property {object}   asset             The asset files and their location
     * @property {function} get               Get an asset URL for a specified type
     * @property {function} getConfig         Get configuration values for specified namespace and type
     */
    "template": {},

    /**
     * The locale data content
     * @type {Object}
     * @property {object}   messages          The locale translation associave array
     * @property {function} get               Get the locale translation of an id
     */
    "locale": {},

    /**
     * The config data content
     * @type {Object}
     * @property {object}   services The services information list
     * @property {object}   config   The config values
     * @property {function} get      Get a value from the config
     * @property {function} service  Get a value from a service
     */
    "config": {},

    /**
     * The ui.xml data content
     * @type {Object}
     */
    "ui": {},

    /**
     * The common-ui.xml data content
     * @type {Object}
     */
    "common-ui": {},

    /**
     * The common-configuration.xml data content
     * @type {Object}
     */
    "common-configuration": {},

    /**
     * The summary content
     * @type {Object}
     * @property {function} get      Get a value from the config
     */
    "summary": {},

    /**
     * The statistics content
     * @type {Object}
     * @property {function} get      Get a value from the config
     */
    "statistics": {

      "get": function () {
        return null;
      }

    }

  };

  /**
   * The XML parsing functions
   * @type {Object}
   * @namespace
   * @private
   */
  var xmlParser = {

    /**
     * The pubinfo.xml parsing function
     * @param  {XMLDocument} xml The XML to parse
     * @author Bruno Sabot
     */
    "pubinfo": function (xml) {

      if (location.protocol === "https:") {
        xmlVariables.managerHost = (xmlVariables.managerHost || xmlVariables.manager_host).replace('http:', 'https:').replace(':80', ':443');
      }

      xmlData.pubinfo.template = null;
      xmlData.pubinfo.contents = null;
      xmlData.pubinfo.statistics = 'publication/contents/statistics.xml';

      var childs = xml.documentElement.childNodes;
      for (var i = 0; i < childs.length; i++) {

        if (childs[i].tagName === 'template') {
          xmlData.pubinfo.template = this.resolver(childs[i].getAttribute('url'));
        } else if (childs[i].tagName === 'contents') {
          xmlData.pubinfo.contents = this.resolver(childs[i].getAttribute('url'));
        } else if (childs[i].tagName === 'statistics') {
          xmlData.pubinfo.statistics = this.resolver(childs[i].getAttribute('url'));
        }

      }

      xmlVariables.root = 'publication/';

      xmlData.pubinfo.get = function (id) {

        return xmlData.pubinfo[id];

      };

    },

    /**
     * The contents.xml parsing function
     * @param  {XMLDocument} xml The XML to parse
     * @author Bruno Sabot
     */
    "contents": function (xml) {

      var contents = xml.querySelector('contents');
      xmlData.contents.config = {
        "pages_nr": parseInt(contents.getAttribute('pages_nr')),
        "shift": parseInt(contents.getAttribute('shift')),
        "prefix": contents.getAttribute('prefix'),
        "padding": parseInt(contents.getAttribute('padding'))
      };

      NIApi.register('page.getCount',
        /**
         * Get the amount of pages in the publication
         * @method   getCount
         * @memberof NIApi.page
         * @example
         * // From the document
         * NIApi.page.getCount().then(function (pageCount) {
         *   console.log("The amount of pages is: ", pageCount);
         * });
         *
         * // From an iframe
         * window.addEventListener("message", function (event) {
         *   if (event.data.method === "page.getCount") {
         *     console.log("The amount of pages is: ", event.data.result);
         *   }
         * }, false);
         * windowElement.postMessage('api/page.getCount', '*');
         */
        function () {
          return Promise.resolve(w.Main.xmlManager.get("common-configuration", "config", "pageCount"));
        }
      );

      xmlData.contents.content = {};
      var content = xml.querySelectorAll('contents > content');
      for (var i = 0; i < content.length; i++) {

        var id = content[i].getAttribute('id').toLowerCase();
        xmlData.contents.content[id] = {
          "id": id,
          "width": parseInt(content[i].getAttribute('width')),
          "height": parseInt(content[i].getAttribute('height')),
          "path": this.resolver(content[i].getAttribute('path')),
          "type": content[i].getAttribute('type'),
          "ext": content[i].getAttribute('ext'),
          "prefix": content[i].getAttribute('prefix')
        };

      }

      xmlData.contents.get = function (id, additionnal) {

        if (typeof (additionnal) !== 'undefined') {
          return xmlData.contents.content[id][additionnal];
        } else {

          if (id === 'thumbnails' && xmlData.contents.content.thumbnails_xdpi && window.devicePixelRatio >= 2) {
            id = 'thumbnailsxdpi';
          }

          switch (id) {

          case "thumbnails_xdpi":
            id = "thumbnailsxdpi";
            break;

          case "zoom_hd":
            id = "zoomhd";
            break;

          case "full_pdf":
            id = "fullPdf";
            break;

          default:
            id = id;

          }

          if (typeof (xmlData.contents.content[id]) === 'undefined') {
            return null;
          }

          var suffix = '';
          if (xmlData.contents.content[id].prefix) {
            suffix += xmlData.contents.content[id].prefix;
          }
          if (xmlData.contents.content[id].ext) {
            suffix += '.' + xmlData.contents.content[id].ext;
          }

          return xmlData.contents.content[id].path + suffix;

        }

      };

    },

    /**
     * The template.xml parsing function
     * @param  {XMLDocument} xml The XML to parse
     * @author Bruno Sabot
     */
    "template": function (xml) {

      var configs = xml.querySelector('configs');
      var preloader = configs.querySelector('preloader');
      xmlData.template.configs = {
        "preloader": {
          "wait_animation_preload": preloader.getAttribute('wait_animation_preload'),
          "backgroundColor": preloader.getAttribute('backgroundColor'),
          "progressColor": preloader.getAttribute('progressColor'),
          "totalSizeColor": preloader.getAttribute('totalSizeColor')
        }
      };

      xmlData.template.asset = {};
      var asset = xml.querySelectorAll('assets > asset');
      for (var i = 0; i < asset.length; i++) {

        var id = asset[i].getAttribute('id');
        xmlData.template.asset[id] = {
          "id": id,
          "url": this.resolver(asset[i].getAttribute('url')),
          "type": asset[i].getAttribute('type'),
          "appdom": asset[i].getAttribute('appdom')
        };

        if (id === 'locale') {
          xmlData.template.asset.localeFlash = {
            "id": id,
            "url": this.resolver(asset[i].getAttribute('url')),
            "type": asset[i].getAttribute('type'),
            "appdom": asset[i].getAttribute('appdom')
          };
        }

      }

      if (!xmlData.template.asset.localeHtml) {
        xmlData.template.asset.localeHtml = xmlData.template.asset.locale;
        xmlData.template.asset.localeHtml.url = 'publication/locale/mobile/messages_' +
          w.Main.xmlManager.getVariable('locale') + '.xml';
      }

      if (xmlData.template.asset.css_html5 && xmlData.template.asset.css_html5.url.indexOf('flash') !== -1) {
        xmlData.template.asset.css_html5 = {
          url: null
        };
      }

      xmlData.template.get = function (id, additionnal) {

        if (xmlData.template.asset[id]) {
          return xmlData.template.asset[id];
        } else {
          return null;
        }

      };

      xmlData.template.getConfig = function (namespace, id) {

        return xmlData.template.configs[namespace][id];

      };

    },

    /**
     * The locale file parsing function
     * @param  {XMLDocument} xml The XML to parse
     * @author Bruno Sabot
     */
    "locale": function (xml) {

      xmlData.locale.messages = xmlData.locale.messages || {};
      var messages = xml.querySelectorAll('message');
      for (var i = 0; i < messages.length; i++) {

        xmlData.locale.messages[messages[i].getAttribute('id')] = messages[i].textContent;

      }

      xmlData.locale.get = function (id) {

        return xmlData.locale.messages[id];

      };

    },

    "localeFlash": function (xml) {

      xmlData.locale.messages = xmlData.locale.messages || {};

      var messages = xml.querySelectorAll('message');
      for (var i = 0; i < messages.length; i++) {

        if (typeof (xmlData.locale.messages[messages[i].getAttribute('id')]) === 'undefined') {
          xmlData.locale.messages[messages[i].getAttribute('id')] = messages[i].textContent;
        }

      }

      var strings = xml.querySelectorAll('string');
      for (var j = 0; j < strings.length; j++) {

        if (typeof (xmlData.locale.messages[strings[j].getAttribute('name')]) === 'undefined') {
          xmlData.locale.messages[strings[j].getAttribute('name')] = strings[j].textContent;
        }

      }

    },

    /**
     * The config.xml file parsing function
     * @param  {XMLDocument} xml The XML to parse
     * @author Bruno Sabot
     */
    "config": function (xml) {

      var emailModule = xml.querySelector("modules email");
      xmlData.config.services = {
        "pdf": {
          "url": this.resolver(xml.querySelector('modules pdf').getAttribute('mergeservice'))
        },
        "email": {
          "url": this.resolver(emailModule.getAttribute("service")),
          "template": this.resolver(emailModule.getAttribute("customTemplatePath")),
          "templateTransferring": this.resolver(emailModule.getAttribute("customTransferringTemplatePath")),
          "subject": this.resolver(emailModule.getAttribute("subject"))
        }
      };

      xmlData.config.config = {
        "search": {},
        "links": {}
      };

      var search = xml.querySelector('search');
      if (search.querySelector('result')) {
        xmlData.config.config.search.prefix = search.querySelector('result').getAttribute('prefix');
        xmlData.config.config.search.suffix = search.querySelector('result').getAttribute('suffix');
      }

      var pageLayoutElement = xml.querySelector('pageLayoutHTML') || xml.querySelector('pageLayout');
      if (pageLayoutElement) {
        xmlData.config.config.pageLayout = pageLayoutElement.getAttribute('value');
      }
      xmlData.config.config.pageLayout = (
        w.Main.urlManager.get('pageLayoutHTML') ||
        w.Main.urlManager.get('pageLayout') ||
        xmlData.config.config.pageLayout
      );

      var deepLinkingElement = xml.querySelector('deepLinking');
      var deepLinking = (deepLinkingElement && deepLinkingElement.getAttribute('value') === 'true');
      xmlData.config.config.deepLinking = deepLinking;

      xmlData.config.config.GAStatsEnabled = false;
      xmlData.config.config.GAStatsId = "";
      xmlData.config.config.GAStatsLabel = "";
      var analyticsElement = xml.querySelector('stats GAStats');

      if (analyticsElement) {

        xmlData.config.config.GAStatsEnabled = true;
        xmlData.config.config.GAStatsId = analyticsElement.getAttribute('account');
        xmlData.config.config.GAStatsLabel = analyticsElement.getAttribute('labelTrack');

      }

      var transferringPromise;
      xmlData.config.config.transferring = xml.querySelector('transferring');
      xmlData.config.config.transferringVariable = "transferring";

      if (xmlData.config.config.transferring) {

        var transferringVariable = "transferring";
        if (xmlData.config.config.transferring.hasAttribute("variable")) {
          transferringVariable = xmlData.config.config.transferring.getAttribute("variable");
        }

        xmlData.config.config.transferringVariable = transferringVariable;

        xmlVariables.transferring = (
          w.Main.urlManager.get(transferringVariable) ||
          (localStorage && localStorage.getItem(transferringVariable)) ||
          xmlVariables[transferringVariable]
        );

        w.Main.transferring = new w.Class.TransferringManager();
        transferringPromise = w.Main.transferring.execute(xmlData.config.config.transferring, xmlVariables);

      }

      // Links behavior
      var linksTag = xml.querySelector('configs > links');
      if (linksTag) {

        xmlData.config.config.links = {
          "mode": linksTag.getAttribute("mode")
        };
        if (linksTag.hasAttribute("duration")) {
          xmlData.config.config.links.duration = parseInt(linksTag.getAttribute("duration"), 10);
        }

      }

      xmlData.config.get = function (id) {

        return xmlData.config.config[id];

      };

      xmlData.config.getService = function (service, id) {

        return xmlData.config.services[service][id];

      };

      NIApi.register('viewer.getCurrentMode',
        /**
         * Get the current publication mode
         * @method   getCurrentMode
         * @memberof NIApi.viewer
         * @example
         * // From the document
         * NIApi.viewer.getCurrentMode().then(function (currentMode) {
         *   console.log("The current mode is: ", currentMode);
         * });
         *
         * // From an iframe
         * window.addEventListener("message", function (event) {
         *   if (event.data.method === "viewer.getCurrentMode") {
         *     console.log("The current mode is: ", event.data.result);
         *   }
         * }, false);
         * windowElement.postMessage('api/viewer.getCurrentMode', '*');
         */
        function () {
          return Promise.resolve(w.Main.xmlManager.get("common-ui", "configs", "pageLayout"));
        }
      );

      return transferringPromise;

    },

    /**
     * The common-ui.xml file parsing function
     * @param  {XMLDocument} xml The XML to parse
     * @author Alessandro Cipolletti
     */
    "common-ui": function (xml) {

      var promise;
      var menuConfig = xml.querySelector("menu_config");
      if (menuConfig) {

        xmlData["common-ui"].menu = {
          left: [],
          center: [],
          right: [],
          burger: []
        };

        var _getItemsName = function (e) {
          return e.getAttribute('name');
        };

        var menus = ["left", "center", "right", "burger"];
        var modes = ["default"];
        var menu, i;

        if (w.Param.isDesktop) {
          modes.push("desktop");
        } else if (w.Param.isTablet) {
          modes.push("tablet");
        } else {
          modes.push("mobile");
        }

        for (var mode in modes) {

          mode = menuConfig.querySelector("mode[name='" + modes[mode] + "']");
          if (mode) {

            for (i in menus) {

              menu = mode.querySelector("menu[name='menu-" + menus[i] + "']");
              if (menu) {
                xmlData["common-ui"].menu[menus[i]] = Array.prototype.slice.call(menu.querySelectorAll("element"))
                  .map(_getItemsName);
              }

            }

            var logoXml = mode.querySelector("element[name='logo'] file");
            if (logoXml) {

              xmlData["common-ui"].logo = {
                scale: logoXml.getAttribute("scale"),
                image: logoXml.getAttribute("url"),
                url: logoXml.getAttribute("href"),
              };

            } else {
              xmlData["common-ui"].logo = xmlData["common-ui"].logo || null;
            }

          }

        }

      } else {

        // NO MENU CONFIG!! WE NEED TO LOAD THE UI.XML!!
        promise = w.Main.xmlManager.parse("ui", "publication/contents/templates/ui.xml");

      }

      xmlData["common-ui"].assets = {};

      var assets = xml.querySelectorAll('template > asset');
      for (var j = 0; j < assets.length; j++) {

        var name = assets[j].getAttribute("name");
        xmlData["common-ui"].assets[name] = {
          "name": name,
          "url": assets[j].getAttribute('url')
        };

        if (name === 'locale') {

          xmlData["common-ui"].assets.localeFlash = {
            "name": name,
            "url": assets[j].getAttribute('url')
          };

        }

      }

      if (!xmlData["common-ui"].assets.localeHtml) {
        xmlData["common-ui"].assets.localeHtml = xmlData["common-ui"].assets.locale;
        xmlData["common-ui"].assets.localeHtml.url = 'publication/locale/mobile/messages_' +
          w.Main.xmlManager.getVariable('locale') + '.xml';
      }

      xmlData["common-ui"].services = {};

      // Services
      var services = xml.querySelectorAll('services > service');
      for (var serviceId = 0; serviceId < services.length; serviceId++) {

        var id = services[serviceId].getAttribute("id");
        xmlData["common-ui"].services[id] = {};
        for (var s = 0; s < services[serviceId].attributes.length; s++) {
          var attribute = services[serviceId].attributes[s];
          xmlData["common-ui"].services[id][attribute.name] = attribute.value;
        }

      }

      xmlData["common-ui"].configs = {};

      // Deep linking
      xmlData["common-ui"].configs.deepLinking = true;
      var deepLinkingTag = xml.querySelector('configs > deep_linking');
      if (deepLinkingTag && deepLinkingTag.getAttribute("value") !== "true") {
        xmlData["common-ui"].configs.deepLinking = false;
      }

      // Page layout
      xmlData["common-ui"].configs.pageLayout = "auto";
      var pageLayoutTag = xml.querySelector('configs > page_layout');
      var pageLayoutHtmlTag = xml.querySelector('configs > page_layout_html');
      if (pageLayoutHtmlTag) {
        xmlData["common-ui"].configs.pageLayout = pageLayoutHtmlTag.getAttribute("value");
      } else if (pageLayoutTag) {
        xmlData["common-ui"].configs.pageLayout = pageLayoutTag.getAttribute("value");
      }

      // Viewer
      var viewerTag = xml.querySelector('configs > viewer');
      xmlData["common-ui"].configs.viewer = {};
      xmlData["common-ui"].configs.viewer.rotateClue = null;
      if (viewerTag) {

        if (viewerTag.hasAttribute("rotate_clue")) {
          xmlData["common-ui"].configs.viewer.rotateClue = viewerTag.getAttribute("rotate_clue");
        }

      }

      // Links behavior
      var linksTag = xml.querySelector('configs > links');
      xmlData["common-ui"].configs.links = {};
      if (linksTag) {

        xmlData["common-ui"].configs.links.mode = linksTag.getAttribute("mode");
        if (linksTag.hasAttribute("duration")) {
          xmlData["common-ui"].configs.links.duration = parseInt(linksTag.getAttribute("duration"), 10);
        }

      }

      xmlData["common-ui"].get = function (subnamespace, id, value) {

        var data = xmlData["common-ui"][subnamespace];
        if (id) {
          data = data[id];
          if (value && data) {
            return data[value];
          } else if (data) {
            return data;
          } else {
            return null;
          }
        } else if (data) {
          return data;
        } else {
          return null;
        }

      };

      return promise;

    },

    /**
     * The common-ui.xml file parsing function
     * @param  {XMLDocument} xml The XML to parse
     * @author Bruno Sabot
     */
    "common-configuration": function (xml) {

      var contents = xml.querySelector('contents');
      xmlData["common-configuration"].config = {
        "pageCount": parseInt(contents.getAttribute("pages_count"), 10),
        "shift": parseInt(contents.getAttribute("shift"), 10)
      };

      xmlData["common-configuration"].contents = {};
      var content = xml.querySelectorAll('contents > content');
      for (var i = 0; i < content.length; i++) {

        var id = content[i].getAttribute('id');
        xmlData["common-configuration"].contents[id] = {
          "id": id,
          "width": parseInt(content[i].getAttribute('width')),
          "height": parseInt(content[i].getAttribute('height')),
          "path": this.resolver(content[i].getAttribute('path'))
        };

      }

      xmlData["common-configuration"].get = function (subnamespace, id, value) {

        var data = xmlData["common-configuration"][subnamespace];
        if (id) {
          data = data[id];
          if (value && data) {
            return data[value];
          } else if (data) {
            return data;
          } else {
            return null;
          }
        } else if (data) {
          return data;
        } else {
          return null;
        }

      };

    },

    /**
     * The ui.xml file parsing function
     * @param  {XMLDocument} xml The XML to parse
     * @author Bruno Sabot
     */
    "ui": function (xml) {

      xmlData.ui.data = {};

      var uiLogoElement = xml.querySelector("uielements>element[id='logo']");
      if (uiLogoElement) {

        var mediaSrc = uiLogoElement.querySelector('content file');
        var mediaLink = uiLogoElement.querySelector('useract');
        var mediaScale = uiLogoElement.querySelector('scale');
        var mediaMobileScale = uiLogoElement.querySelector('mobilescale');

        if (mediaSrc && mediaSrc.getAttribute('url').indexOf('.swf') < 0) {

          xmlData.ui.data.logo = {
            "image": mediaSrc.getAttribute('url'),
            "scale": (mediaMobileScale === null && mediaScale === null)
          };

          if (mediaLink !== null) {
            xmlData.ui.data.logo.url = mediaLink.getAttribute('param');
          }

        }

      }

      var uiBackground = xml.querySelector("element[id='background']");

      if (uiBackground) {

        xmlData.ui.data.background = {};

        var uiBackgroundFile = uiBackground.querySelector('content file');
        if (uiBackgroundFile) {
          xmlData.ui.data.background.image = this.resolver(uiBackgroundFile.getAttribute('url'));
        }

        var uiBackgroundScale = uiBackground.querySelector('position scale');
        if (uiBackgroundScale) {
          xmlData.ui.data.background.scale = this.resolver(uiBackgroundScale.getAttribute('fit'));
        }

      }

      xmlData.ui.data.menu = {};
      var i, id, priority, items = [],
        elements = [];
      var positions = ["left", "center", "right"];
      var priorities = ["lowest", "low", "medium", "high", "highest"];

      function _filterElementsByPriority(el) {
        return el.name !== this.name || priorities.indexOf(el.priority) > priorities.indexOf(this.priority);
      }

      function _filterElementByName(el) {
        return el.name === this.name;
      }

      function addElement(element) {

        elements = elements.filter(_filterElementsByPriority, element);
        if (elements.filter(_filterElementByName, element).length === 0) {
          elements.push(element);
        }

      }

      var hasLogo = false;
      for (var position = 0; position < positions.length; position++) {

        elements = [];
        items = xml.querySelectorAll("uielements [id='menu_" + positions[position] + "'] element");
        items = Array.prototype.slice.call(items, 0);

        for (i = 0; i < items.length; i++) {

          if (typeof (items[i].getAttribute("priority")) !== "string") {
            items[i].setAttribute("priority", "medium");
          }

          id = items[i].getAttribute("id");
          priority = items[i].getAttribute("priority");

          addElement({
            name: id,
            priority: priority
          });

          if (id === "logo") {
            hasLogo = true;
          }

        }

        xmlData.ui.data.menu[positions[position]] = elements;

      }

      if (hasLogo === false && xmlData.ui.data.logo) {
        xmlData.ui.data.menu.center.push({
          name: "logo",
          priority: "highest"
        });
      }

      xmlData.ui.data.pageShadow = (xml.querySelector('ShadowElement') !== null);

      xmlData.ui.get = function (id) {

        return xmlData.ui.data[id];

      };

    },

    /**
     * The summary.xml file parsing function
     * @param  {XMLDocument} xml The XML to parse
     * @author Bruno Sabot
     */
    "summary": function (xml) {

      xmlData.summary.xml = xml;

      xmlData.summary.get = function () {

        return xmlData.summary.xml;

      };

    },

    /**
     * The statistics.xml file parsing function
     * @param  {XMLDocument} xml The XML to parse
     * @author Bruno Sabot
     */
    "statistics": function (xml) {

      var statistics = xml.querySelector("Statistics");

      xmlData.statistics.version = parseInt(statistics.getAttribute("version") || "1", 10);
      xmlData.statistics.servers = statistics.querySelector("servers");
      xmlData.statistics.events = statistics.querySelector("events");
      xmlData.statistics.pages = statistics.querySelector("pages");

      xmlData.statistics.get = function (id) {

        return xmlData.statistics[id];

      };

    }

  };

  /**
   * An object to get and manage XML configuration files
   * @constructs XmlManager
   * @memberof Class
   * @author Bruno Sabot
   */
  function XmlManager() {}

  /**
   * Get the value of an XML Variable
   * @param  {String} id The XML variable name that we want
   * @return {String}    The value of the variable
   * @author Bruno Sabot
   */
  XmlManager.prototype.getVariable = function (id) {

    if (w.Main.startupManager.get("reader.configurationVersion") !== 2) {
      switch (id) {
      case "manager_host":
        return xmlVariables.managerHost;
      case "client_id":
        return xmlVariables.clientId;
      case "id":
        return xmlVariables.aspgenerationId;
      }
    }

    return xmlVariables[id];

  };

  /**
   * Get all the values of XML Variables
   * @return {Object} An associave array with all the values
   * @author Bruno Sabot
   */
  XmlManager.prototype.getVariables = function () {

    return xmlVariables;

  };

  /**
   * get the data extracted for an XML file
   * @param  {String} namespace    The XML name in which we want to find data
   * @param  {String} subnamespace The data namespace in the XML
   * @param  {String} key          The data key
   * @param  {String} additionnal  An additionnal key to recover
   * @return {mixed}               The configuration value
   * @author Bruno Sabot
   */
  XmlManager.prototype.get = function (namespace, subnamespace, key, additionnal) {

    var value = this.getProxy(namespace, subnamespace, key, additionnal);
    if (typeof (value) === "string") {
      return this.resolver(value);
    }
    // @TODO: Automate objects, array, etc.

    return value;

  };

  /**
   * Map calls from new configuration to the old one if needed
   * @param  {String} namespace    The XML name in which we want to find data
   * @param  {String} subnamespace The data namespace in the XML
   * @param  {String} key          The data key
   * @param  {String} additionnal  An additionnal key to recover
   * @return {mixed}               The configuration value
   * @author Bruno Sabot
   */
  XmlManager.prototype.getProxy = function (namespace, subnamespace, key, additionnal) {

    if (
      w.Main.startupManager.get("reader.configurationVersion") === 2 &&
      namespace === "config" && subnamespace === "transferringVariable"
    ) {
      return "transferring";
    } else if (namespace === "config") {
      if (!xmlData.config.get && subnamespace === "GAStatsEnabled") {
        return false;
      }
      return xmlData.config.get(subnamespace, key, additionnal);
    }

    // TODOS!!
    if (namespace === "summary") {
      return xmlData.summary.get(subnamespace, key, additionnal);
    } else if (namespace === "ui" && subnamespace === "background") {
      return xmlData.ui.get("background");
    } else if (namespace === "ui" && subnamespace === "logo") {
      return xmlData.ui.get("logo");
    } else if (namespace === "ui" && subnamespace === "menu") {
      return xmlData.ui.get("menu");
    } else if (namespace === "pubinfo") {
      return xmlData.pubinfo.get(subnamespace, key, additionnal);
    } else if (namespace === "common-ui" && subnamespace === "logo") {
      return (
        xmlData[namespace].get && xmlData[namespace].get(subnamespace, key, additionnal)
      ) || (xmlData.ui.get && xmlData.ui.get("logo"));
    }

    if (w.Main.startupManager.get("reader.configurationVersion") === 2) {

      if (typeof (subnamespace) === 'undefined') {
        return xmlData[namespace];
      }

      return xmlData[namespace].get(subnamespace, key, additionnal);

    } else {
      if (namespace === "common-ui" && subnamespace === "service") {
        return xmlData.config.getService(key, additionnal);
      } else if (namespace === "common-ui" && subnamespace === "configs" && key === "pageLayout") {
        return xmlData.config.config.pageLayout;
      } else if (namespace === "common-ui" && subnamespace === "configs" && key === "links") {
        return xmlData.config.get(key)[additionnal];
      } else if (namespace === "common-ui" && subnamespace === "configs" && key === "viewer") {
        return null;
      } else if (namespace === "common-ui" && subnamespace === "assets") {
        return xmlData.template.get(key, additionnal);
      } else if (namespace === "common-ui" && subnamespace === "logo") {
        return xmlData.ui.get(subnamespace, key, additionnal);
      } else if (namespace === "common-configuration" && subnamespace === "config" && key === "pageCount") {
        return xmlData.contents.config.pages_nr;
      } else if (namespace === "common-configuration" && subnamespace === "config" && key === "shift") {
        return xmlData.contents.config.shift;
      } else if (namespace === "common-configuration" && subnamespace === "contents") {
        if (additionnal === "path") {
          return xmlData.contents.get(key);
        } else {
          return xmlData.contents.get(key, additionnal);
        }
      } else if (namespace === "statistics") {
        return xmlData.statistics.get(subnamespace, key, additionnal);
      } else if (namespace === "locale") {
        return xmlData.locale.get(subnamespace, key, additionnal);
      } else if (namespace === "common-ui" && subnamespace === "menu") {
        return null;
      } else if (namespace === "common-ui" && subnamespace === "services" && key === "sendmail") {
        return xmlData.config.getService("email", additionnal);
      } else {
        console.log(namespace, subnamespace, key, additionnal);
      }

    }

  };

  /**
   * Get a specific XML document
   * @param  {string} name The XML associated name
   * @author Bruno Sabot
   */
  XmlManager.prototype.getXml = function (name) {

    if (xmlDocuments[name]) {
      return xmlDocuments[name];
    }

    return;

  };

  /**
   * The XML variable system resolver
   * @return {String} variable The string to resolve
   * @return {String}          The resolved string
   * @function
   * @author Bruno Sabot
   */
  XmlManager.prototype.resolver = function () {

    function replacer(match, p1) {

      if (typeof (xmlVariables[p1]) !== 'undefined') {
        return xmlVariables[p1];
      } else {
        return match;
      }

    }

    return function (variable) {

      if (variable) {

        return variable
          .replace(/^~\//g, 'publication/')
          .replace(/\$([^\$]*)\$/g, replacer)
          .replace(/\$\{([A-Za-z0-9-_]+)\}/gi, replacer);

      } else {
        return variable;
      }

    };

  }();

  /**
   * The XML parser. Get data from the file and do the right calls
   * @param  {String}   name     The XML file alias
   * @param  {String}   url      The XML file URL
   * @author Bruno Sabot
   */
  XmlManager.prototype.parse = function (name, url) {

    return w.Utils.promiseXHR('GET', url).then(function (xhr) {

      var data = xhr.responseXML;

      if (!data) {
        var domParser = new DOMParser();
        data = domParser.parseFromString(xhr.responseText, 'text/xml');
      }

      xmlDocuments[name] = data;

      var variables = data.getElementsByTagName('variables')[0];
      if (variables) {

        var children = variables.childNodes;
        for (var i = 0; i < children.length; i++) {

          if (children[i].nodeType === 1 && children[i].getAttribute('value')) {

            var varName;
            if (w.Main.startupManager.get("reader.configurationVersion") === 2) {
              varName = children[i].getAttribute("id");
            } else {
              varName = children[i].tagName;
            }

            xmlVariables[varName] = this.resolver(children[i].getAttribute('value'));

            if (varName === "root") {
              xmlVariables.root = "./publication/";
            }

            // Media doesn't contain the right value
            if (varName === 'media' && location.href.indexOf('isApp') > -1) {
              xmlVariables.media = xmlVariables.media.replace('assets/', '');
            }

          }

        }

        for (var j in xmlVariables) {
          xmlVariables[j] = this.resolver(xmlVariables[j]);
        }

      }

      var parserResult = xmlParser[name].call(this, data);
      if (parserResult instanceof Promise) {
        return parserResult;
      } else {
        return Promise.resolve(true);
      }

    }.bind(this))['catch'](function () {
      // The XML is not found... Continue at our own risks
    });

  };

  w.Class.XmlManager = XmlManager;

})(webpublicationNamespace);

(function (w) {

  var data = {
    "reader": {
      "type": "auto",
      "mode": "3d"
    },
    "ui": {
      "paging": {
        "mode": ["bottom", "lateral"],
        "lateral": {
          "hasPrevNext": true,
          "hasFirstLast": true,
          "display": "near" // near or sticky
        }
      },
      "menu": {
        "mode": ["aside", "topnav"]
      },
      "carousel": {
        "mode": ["standard"]
      },
      "zoom": {
        "mode": ["doubleclick", "pinch"]
      },
      "theme": {
        "mode": ["v4"]
      }
    },
    "core": {
      "session": "client",
      "viewer": "v4",
      "viewerDirection": "horizontal",
      "mode": ["canvas"],
      "format": ["img"]
    }
  };

  /**
   * An object to get and manage startup.json configuration file
   * @constructs StartupManager
   * @memberof Class
   * @author Bruno Sabot
   */
  function StartupManager() {}

  StartupManager.prototype._set = function (key, value) {

    /* jshint -W061 */
    eval("data." + key + '="' + value + '"');
    /* jshint +W061 */

  };

  /**
   * Start the startup.json recovery process
   * @return {Promise} A promise that resolve when the data is loaded
   * @author Bruno Sabot
   */
  StartupManager.prototype.start = function () {

    return w.Utils.promiseXHR('GET', 'publication/contents/templates/startup.json').then(function (xhr) {

      if (xhr.responseText) {
        data = JSON.parse(xhr.responseText);
      }

      return Promise.resolve(true);

    })["catch"](function (e) {

      if (console && console.error) {
        console.error("Failed to load the startup.json. There is probably a syntax error. Message: " + e.toString());
      }

      return Promise.resolve(true);

    });

  };

  /**
   * Get a key from the startup data
   * @param  {string} key The key to resolve
   * @return {mixed}      The data associated to that key
   * @author Bruno Sabot
   */
  StartupManager.prototype.get = function (key) {

    // overload ui to handle the device mode
    if (key.indexOf('ui.') === 0) {

      var type = w.Param.userAgent.device.type;
      var deviceType = type.charAt(0).toUpperCase() + type.slice(1);
      var deviceTypeKey = "ui" + deviceType;

      var deviceValue = this.get(key.replace(/^ui\./, deviceTypeKey + '.'));
      if (deviceValue !== null) {
        return deviceValue;
      }

    }

    // Do the original magic
    var value = null;
    var keys = key.split('.');
    var target = data;

    for (var i = 0; i < keys.length; i++) {

      if (typeof (target[keys[i]]) !== 'undefined') {
        target = target[keys[i]];
      } else {
        return null;
      }

    }

    return target;

  };

  /**
   * Check if a value is available in a key
   * @param  {string}  key   The key to resolve
   * @param  {mixed}   value The value to find
   * @return {Boolean}       The availability status of the the value in the key
   * @author Bruno Sabot
   */
  StartupManager.prototype.has = function (key, value) {

    var target = this.get(key);

    return (target instanceof Array && target.indexOf(value) > -1);

  };

  w.Class.StartupManager = StartupManager;

})(webpublicationNamespace);

(function (w) {

  var _build = function () {

    if (w.Main.startupManager.get("reader.url.flash") && this.mode === "flash") {
      location.href = w.Main.startupManager.get("reader.url.flash") + location.search + location.hash;
      return;
    }
    if (w.Main.startupManager.get("reader.url.html") && this.mode === "html") {
      location.href = w.Main.startupManager.get("reader.url.html") + location.search + location.hash;
      return;
    }

    if (typeof (jQuery) !== "undefined") {
      $.get(this.getBody(), function (data) {
        $(w.Param.viewBody).append(data);
      });
      $.get(this.getHead(), function (data) {

        $(w.Param.viewHead).append(data);

        if (this.mobileSupported === true) {
          $('.noflash-mobile').css('display', 'none');
        }

      }.bind(this));

      $('body').append(
        '<link rel="stylesheet" id="flash-style" type="text/css" href="global_conf/css/flash.css" />'
      );

    } else {

      w.Main.templateManager.load(this.getBody(), w.Param.viewBody);
      w.Main.templateManager.load(this.getHead(), w.Param.viewHead);

      if (this.mobileSupported === true) {

        var mobiles = document.querySelectorAll('.noflash-mobile');
        for (var i = 0; i < mobiles.length; i++) {
          mobiles[i].style.display = 'none';
        }

      }

    }

  };

  function Switcher() {

    w.Param.viewBody.setAttribute("touch-action", "none");
    w.Main.templateManager = new w.Class.TemplateManager();
    w.Main.urlManager = new w.Class.UrlManager();

    /**
     * A boolean value that says if the reader is local
     * @type {boolean}
     * @memberof w.Param
     */
    w.Param.isLocalReader = location.protocol !== 'http:' && location.protocol !== 'https:';

    /**
     * Boolean that enable the app mode or the desktop mode
     * @type {boolean}
     * @memberof w.Param
     */
    w.Param.isApp = (location.protocol === 'file:' || location.protocol === 'ms-local-stream:');

    /**
     * A boolean value that says if the device is touchable
     * @type {boolean}
     * @memberof w.Param
     */
    w.Param.isTouch = ('ontouchstart' in document.documentElement);

    this.setMode();
    this.createSession();

    if (
      w.Param.userAgent.browser.name === w.Param.userAgent.BROWSER.IE &&
      w.Param.userAgent.browser.version < 11
    ) {

      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'global_conf/jquery.js';
      script.onreadystatechange = function () {
        if (script.readyState === 'loaded' || script.readyState === 'complete') {
          _build.call(this);
        }
      }.bind(this);
      document.getElementsByTagName('head')[0].appendChild(script);

    } else {
      _build.call(this);
    }

  }

  Switcher.prototype.mode = 'flash';

  Switcher.prototype.getBody = function () {

    return './global_conf/template/' + this.mode + '/body.html';

  };

  Switcher.prototype.getHead = function () {

    return './global_conf/template/' + this.mode + '/head.html';

  };

  /**
   * Create a unique session id based on the client with ou without the publication ID.
   * @author Bruno Sabot
   */
  Switcher.prototype.createSession = function () {

    var clientId = w.Main.xmlManager.getVariable('client_id');
    var pubId = w.Main.xmlManager.getVariable('id');
    var mode = w.Main.startupManager.get('core.session') || 'single';
    var clientCookies = w.Utils.getCookie('session_' + clientId);
    var prefix = clientId + '_';

    clientCookies = clientCookies ? clientCookies.split(';') : [];

    if (mode === 'single') {
      prefix = pubId + prefix;
    }

    for (var i = 0; i < clientCookies.length; i++) {
      if (atob(clientCookies[i]).indexOf(prefix) === 0) {
        w.Param.sessionId = clientCookies[i];
        w.Param.sessionId = w.Param.sessionId.replace(/=/g, '');
        return;
      }
    }

    w.Param.sessionId = btoa(prefix + Math.random().toString().substring(2));
    clientCookies.push(w.Param.sessionId);
    w.Utils.setCookie('session_' + clientId, clientCookies.join(';'), 1);
    w.Param.sessionId = w.Param.sessionId.replace(/=/g, '');

  };

  Switcher.prototype.setMode = function (mode) {

    if (
      w.Main.urlManager.get('version') === 'flash' ||
      w.Main.startupManager.get('reader.type') === 'flash'
    ) {
      this.mode = 'flash';
    } else if (
      w.Main.urlManager.contains('forceMobile') === true ||
      w.Main.urlManager.get('version') === 'html' ||
      w.Main.urlManager.get('isApp') === 'true' ||
      w.Main.startupManager.get('reader.type') === 'html'
    ) {
      this.mode = 'html';
    } else if (typeof (mode) === 'undefined') {

      if (
        w.Param.userAgent.device.type === w.Param.userAgent.FORMAT.TABLET ||
        w.Param.userAgent.device.type === w.Param.userAgent.FORMAT.PHONE ||
        w.Param.userAgent.device.type === w.Param.userAgent.FORMAT.PHABLET
      ) {
        this.mode = 'html';
      } else {
        this.mode = 'flash';
      }

    } else {
      this.mode = mode;
    }

    this.mobileSupported = true;

    // Supported browsers
    // @TODO: make the reverse: disable not supported devices
    if (
      w.Param.userAgent.browser.name !== w.Param.userAgent.BROWSER.ANDROID &&
      w.Param.userAgent.browser.name !== w.Param.userAgent.BROWSER.BLACKBERRY &&
      w.Param.userAgent.browser.name !== w.Param.userAgent.BROWSER.CHROME &&
      w.Param.userAgent.browser.name !== w.Param.userAgent.BROWSER.EDGE &&
      w.Param.userAgent.browser.name !== w.Param.userAgent.BROWSER.FIREFOX &&
      w.Param.userAgent.browser.name !== w.Param.userAgent.BROWSER.SAFARI &&
      w.Param.userAgent.browser.name !== w.Param.userAgent.BROWSER.TIZEN &&
      w.Param.userAgent.os.name !== w.Param.userAgent.OS.IOS &&
      w.Param.userAgent.os.name !== w.Param.userAgent.OS.ANDROID &&
      (
        w.Param.userAgent.browser.name === w.Param.userAgent.BROWSER.IE &&
        w.Param.userAgent.browser.version >= 11
      ) !== true
    ) {
      this.mode = 'flash';
      this.mobileSupported = false;
    }

  };

  Switcher.prototype.rebuild = function () {

    this.mode = 'html';

    return _build.call(this);

  };

  w.Class.Switcher = Switcher;

})(webpublicationNamespace);

(function (w) {

  w.Param.viewBody = document.body;
  w.Param.viewHead = document.getElementsByTagName('head')[0];
  w.Param.userAgent = new w.Class.UserAgentManager();

  /**
   * Define if the device is a desktop
   * @type {boolean}
   * @memberof w.Param
   */
  w.Param.isDesktop = w.Param.userAgent.isDesktop();

  /**
   * Define if the device is a phone
   * @type {boolean}
   * @memberof w.Param
   */
  w.Param.isPhone = w.Param.userAgent.isPhone();

  /**
   * Define if the device is a tablet or a phablet
   * @type {boolean}
   * @memberof w.Param
   */
  w.Param.isTablet = w.Param.userAgent.isTablet();

  /**
   * Define if the device is a phablet
   * @type {boolean}
   * @memberof w.Param
   */
  w.Param.isPhablet = w.Param.userAgent.isPhablet();

  /**
   * Define if the device is a unidentified
   * @type {boolean}
   * @memberof w.Param
   */
  w.Param.isUnknown = w.Param.userAgent.isUnknown();

  w.Main.startupManager = new w.Class.StartupManager();
  return w.Main.startupManager.start().then(function () {

    w.Main.xmlManager = new w.Class.XmlManager();

    var promise = Promise.resolve();
    if (w.Main.startupManager.get("reader.configurationVersion") !== 2) {
      promise = promise.then(Promise.reject);
    }

    promise.then(function () {

      return w.Main.xmlManager.parse("common-configuration", w.Param.pathRoot +
          "contents/common-configuration.xml")
        .then(function () {

          if (typeof (w.Main.xmlManager.getXml('common-configuration')) === "undefined") {

            console && console.error && console.error(
              "No new conf file available, switching to the old model");
            w.Main.startupManager._set("reader.configurationVersion", 1);
            return Promise.reject();

          }

          return w.Main.xmlManager.parse("common-ui", w.Param.pathRoot + "contents/templates/common-ui.xml");

        })
        .then(function () {

          w.Main.switcher = new w.Class.Switcher();

          w.Main.xmlManager.parse("statistics", w.Param.pathRoot + "contents/statistics.xml")
            .then(w.require.bind(w, ["../../global_conf/common.js"]))
            .then(function () {

              if (w.Main.xmlManager.get("statistics", "version") === 2) {
                w.Main.trackerManager = new w.Class.TrackerManager();
              }

            });

        });

    })["catch"](function () {

      w.Main.xmlManager.parse("pubinfo", w.Param.pathRoot + "contents/pubinfo.xml")
        .then(function () {
          return w.Main.xmlManager.parse("contents", w.Main.xmlManager.get("pubinfo", "contents"));
        })
        .then(function () {
          return w.Main.xmlManager.parse("template", w.Main.xmlManager.get("pubinfo", "template"));
        })
        .then(function () {

          w.Main.switcher = new w.Class.Switcher();

          w.Main.xmlManager.parse("statistics", w.Main.xmlManager.get("pubinfo", "statistics"))
            .then(w.require.bind(w, ["../../global_conf/common.js"]))
            .then(function () {

              if (w.Main.xmlManager.get("statistics", "version") === 2) {
                w.Main.trackerManager = new w.Class.TrackerManager();
              }

            });

        });

    });

  });

})(webpublicationNamespace);

(function (w) {

  var data = {};

  function CommonLayout() {}

  CommonLayout.prototype.fetch = function () {

    var customLayout = w.Main.xmlManager.get("common-ui", "assets", "common_layout");
    if (!customLayout) {
      return Promise.resolve(true);
    }

    var url =  w.Utils.resolveVariable(customLayout.url ? customLayout.url : customLayout);
    w.Utils.promiseXHR('GET', url).then(function (xhr) {

      if (xhr.responseText) {
        data = JSON.parse(xhr.responseText);
      }
      return Promise.resolve(true);

    })["catch"](function () {
      return Promise.resolve(true);
    });

  };

  CommonLayout.prototype.set = function (key, value) {

    var keys = key.split('.');
    var target = data;

    for (var i = 0; i < keys.length - 1; i++) {

      if (!target.hasOwnProperty(keys[i])) {
        target[keys[i]] = {};
      }
      target = target[keys[i]];

    }
    target[keys[keys.length - 1]] = value;

  };

  CommonLayout.prototype.get = function (key) {

    // Do the original magic
    var value = null;
    var keys = key.split('.');
    var target = data;

    for (var i = 0; i < keys.length; i++) {

      if (typeof (target[keys[i]]) !== 'undefined') {
        target = target[keys[i]];
      } else {
        return null;
      }

    }

    return target;

  };

  w.Class.CommonLayout = CommonLayout;

})(webpublicationNamespace);
